import { GraphQLClient } from 'graphql-request';
import { Extended } from '../../responseTypes/singlePlayResponse';
// import * as Dom from 'graphql-request/dist/types.dom';
// import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _FieldSet: any;
}

export enum Action {
  Set = 'SET',
  Update = 'UPDATE'
}

export interface AdConfig {
  __typename?: 'AdConfig';
  campaignType?: Maybe<Scalars['String']>;
  refreshRate?: Maybe<Scalars['Int']>;
  screens?: Maybe<Array<Maybe<AdScreen>>>;
  visibility?: Maybe<Scalars['Boolean']>;
}

export interface AdConfigByUserType {
  __typename?: 'AdConfigByUserType';
  guestUser?: Maybe<AdConfig>;
  premiumUser?: Maybe<AdConfig>;
  registeredUser?: Maybe<AdConfig>;
}

export interface AdData {
  __typename?: 'AdData';
  adDimensions?: Maybe<Array<Maybe<Array<Maybe<Scalars['Int']>>>>>;
  adLayoutType?: Maybe<Scalars['String']>;
  adTag?: Maybe<Scalars['String']>;
  adTarget?: Maybe<Array<Maybe<AdTargetKeyValuePair>>>;
  adType?: Maybe<Scalars['String']>;
  divId?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
}

export interface AdDetail {
  __typename?: 'AdDetail';
  adDetailKeyValue?: Maybe<AdDetailKeyValuePair>;
  interstitialAd?: Maybe<InterstitialAdConfig>;
  mastHeadAd?: Maybe<AdConfigByUserType>;
  mastheadImage?: Maybe<Scalars['String']>;
  mastheadVideo?: Maybe<Scalars['String']>;
  nativeTagAd?: Maybe<AdConfigByUserType>;
}

/** https://apidocs.zee5.com/spapi/singlePlayback/displayAds.json */
export interface AdDetailFilter {
  age?: InputMaybe<Scalars['Int']>;
  ageGroup?: InputMaybe<Scalars['String']>;
  appVersion?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  checkParentalControl?: InputMaybe<Scalars['Boolean']>;
  country: Scalars['String'];
  dekey?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  guestToken?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  platformName: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  userLanguage?: InputMaybe<Scalars['String']>;
}

export interface AdDetailKeyValuePair {
  __typename?: 'AdDetailKeyValuePair';
  age?: Maybe<Scalars['String']>;
  appVersion?: Maybe<Scalars['String']>;
  bdSource?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  checkParentalControl?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  isLat?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  platformName?: Maybe<Scalars['String']>;
  ppid?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  translation?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  userLanguage?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
  zid?: Maybe<Scalars['String']>;
}

export interface AdInterval {
  __typename?: 'AdInterval';
  tag?: Maybe<Scalars['String']>;
  tagName?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
}

export interface AdScreen {
  __typename?: 'AdScreen';
  adData?: Maybe<Array<Maybe<AdData>>>;
  screenId?: Maybe<Scalars['String']>;
}

export interface AdTargetKeyValuePair {
  __typename?: 'AdTargetKeyValuePair';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

export interface AdVisibility {
  __typename?: 'AdVisibility';
  isAdVisible?: Maybe<Scalars['Boolean']>;
}

export interface AdsResponse {
  __typename?: 'AdsResponse';
  bingAds?: Maybe<Array<Maybe<BingAd>>>;
  pageLoadPingUrl?: Maybe<Scalars['String']>;
  pingUrlBase?: Maybe<Scalars['String']>;
  visibilityFeedbackUrl?: Maybe<Scalars['String']>;
}

export interface AdvanceRenewal {
  __typename?: 'AdvanceRenewal';
  plans?: Maybe<Array<Maybe<AdvanceRenewalPlan>>>;
  previousPlanId?: Maybe<Scalars['String']>;
  resultType?: Maybe<Scalars['String']>;
}

export interface AdvanceRenewalPlan {
  __typename?: 'AdvanceRenewalPlan';
  actualValue?: Maybe<Scalars['Float']>;
  discountAmount?: Maybe<Scalars['Float']>;
  discountPercentage?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  remainingDays?: Maybe<Scalars['Int']>;
}

export interface AnswerResponse {
  __typename?: 'AnswerResponse';
  correctAnswerId?: Maybe<Scalars['String']>;
  isAnswerCorrect?: Maybe<Scalars['Boolean']>;
  questionId?: Maybe<Scalars['String']>;
  userSelectedOptionId?: Maybe<Scalars['String']>;
}

export enum AssetSubType {
  Livetv = 'livetv',
  Movies = 'movies',
  Tvshow = 'tvshow',
  Zee5originals = 'zee5originals'
}

export interface AttributeKeyValuePair {
  __typename?: 'AttributeKeyValuePair';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

export interface Award {
  __typename?: 'Award';
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
}

export interface BackToPartnerConfig {
  __typename?: 'BackToPartnerConfig';
  androidDeepLink?: Maybe<Scalars['String']>;
  androidPartnerDeepLink?: Maybe<Scalars['String']>;
  deepLink?: Maybe<Scalars['String']>;
  iosDeepLink?: Maybe<Scalars['String']>;
  iosPartnerDeepLink?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  webLink?: Maybe<Scalars['String']>;
}

export interface Batsman {
  __typename?: 'Batsman';
  ballsFaced?: Maybe<Scalars['String']>;
  dismissal?: Maybe<Scalars['String']>;
  dismissalDetails?: Maybe<Scalars['String']>;
  fours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isBatting?: Maybe<Scalars['Boolean']>;
  isOnStrike?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  runs?: Maybe<Scalars['String']>;
  sixes?: Maybe<Scalars['String']>;
  strikeRate?: Maybe<Scalars['String']>;
}

export interface BattingTable {
  __typename?: 'BattingTable';
  columns?: Maybe<Array<Maybe<TableColumns>>>;
  rows?: Maybe<Array<Maybe<BattingTableRow>>>;
}

export interface BattingTableRow {
  __typename?: 'BattingTableRow';
  ballsFaced?: Maybe<Scalars['String']>;
  batsman?: Maybe<Batsman>;
  fours?: Maybe<Scalars['String']>;
  runs?: Maybe<Scalars['String']>;
  sixes?: Maybe<Scalars['String']>;
  strikeRate?: Maybe<Scalars['String']>;
}

export interface BingAd {
  __typename?: 'BingAd';
  currency?: Maybe<Scalars['String']>;
  currencySymbol?: Maybe<Scalars['String']>;
  discountPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  impressionToken?: Maybe<Scalars['String']>;
  itemOffered?: Maybe<ItemDetails>;
  pageLoadPingUrl?: Maybe<Scalars['String']>;
  pingUrlBase?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  seller?: Maybe<SellerDetails>;
  url?: Maybe<Scalars['String']>;
  urlPingSuffix?: Maybe<Scalars['String']>;
  visibilityFeedbackUrl?: Maybe<Scalars['String']>;
}

export interface BlockerScreenConfig {
  __typename?: 'BlockerScreenConfig';
  banner?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  primaryCta?: Maybe<PartnerSettingPrimaryCta>;
  title?: Maybe<Scalars['String']>;
}

export interface Bowler {
  __typename?: 'Bowler';
  economy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isBowling?: Maybe<Scalars['Boolean']>;
  isCurrentBowler?: Maybe<Scalars['Boolean']>;
  maidens?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  overs?: Maybe<Scalars['String']>;
  runsConceded?: Maybe<Scalars['String']>;
  wickets?: Maybe<Scalars['String']>;
}

export interface BowlingTable {
  __typename?: 'BowlingTable';
  columns?: Maybe<Array<Maybe<TableColumns>>>;
  rows?: Maybe<Array<Maybe<BowlingTableRow>>>;
}

export interface BowlingTableRow {
  __typename?: 'BowlingTableRow';
  bowler?: Maybe<Bowler>;
  economy?: Maybe<Scalars['String']>;
  maidens?: Maybe<Scalars['String']>;
  overs?: Maybe<Scalars['String']>;
  runsConceded?: Maybe<Scalars['String']>;
  wickets?: Maybe<Scalars['String']>;
}

export interface CampaignDetails {
  __typename?: 'CampaignDetails';
  id: Scalars['ID'];
}

export interface CartAbandonmentDetails {
  __typename?: 'CartAbandonmentDetails';
  discountPercentage?: Maybe<Scalars['Int']>;
  lastOrderId?: Maybe<Scalars['String']>;
  lastTransactionDate?: Maybe<Scalars['String']>;
  packId?: Maybe<Scalars['String']>;
  promoCode?: Maybe<Scalars['String']>;
  vodType?: Maybe<Scalars['String']>;
}

export interface CelebrityDetails {
  __typename?: 'CelebrityDetails';
  awards?: Maybe<Array<Maybe<Award>>>;
  bio?: Maybe<Scalars['String']>;
  castTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  educationDetails?: Maybe<Education>;
  family?: Maybe<Family>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']>;
  netWorth?: Maybe<NetWorth>;
  nickNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  physicalDimension?: Maybe<Dimension>;
  seoId?: Maybe<Scalars['String']>;
  socialMedia?: Maybe<Array<Maybe<AttributeKeyValuePair>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface ChannelGenreFilter {
  country?: InputMaybe<Scalars['String']>;
  /** Comma separated String of genre : News,Movie,Entertainment,Devotional */
  genres: Scalars['String'];
  /** Comma separated String of language : en,hi,kn,ta */
  languages?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  /** Value : mostwatchedchannels / channel_number */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Value : ASC / DESC */
  sortOrder?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface ChannelId {
  __typename?: 'ChannelId';
  id?: Maybe<Scalars['String']>;
}

export interface ChannelLanguageFilter {
  country?: InputMaybe<Scalars['String']>;
  /** Comma separated String of genre */
  genres: Scalars['String'];
  /** Comma separated String of language */
  languages: Scalars['String'];
  /** Value : mostwatchedchannels / channel_number */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Value : ASC / DESC */
  sortOrder?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface ClcVideo {
  __typename?: 'ClcVideo';
  timeStamps?: Maybe<Array<Maybe<Scalars['Int']>>>;
  videoReferenceId?: Maybe<Scalars['String']>;
}

export interface Collection extends Pagination {
  __typename?: 'Collection';
  contentPartner?: Maybe<ContentPartner>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  originalTitle?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  rails?: Maybe<Array<Maybe<Rail>>>;
  size?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title: Scalars['String'];
  totalResults?: Maybe<Scalars['Int']>;
  assetSubType?: Maybe<Scalars['String']>;
}

export interface CollectionFilter {
  appVersion?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  itemLimit?: InputMaybe<Scalars['Int']>;
  kidsSafe?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface Color {
  __typename?: 'Color';
  alpha?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['String']>;
}

export interface Comment {
  __typename?: 'Comment';
  commentText?: Maybe<Scalars['String']>;
  dislikeCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  likeCount?: Maybe<Scalars['Int']>;
  shareCount?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  userProfileImage?: Maybe<Scalars['String']>;
}

export interface Commentary {
  __typename?: 'Commentary';
  delivery?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  entitySportsEventId?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  outcomeType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface CompanionAd {
  __typename?: 'CompanionAd';
  adData?: Maybe<Array<Maybe<AdData>>>;
  adVisibility?: Maybe<Scalars['Boolean']>;
  campaignType?: Maybe<Scalars['String']>;
  guestUser?: Maybe<AdConfig>;
  premiumUser?: Maybe<AdConfig>;
  registeredUser?: Maybe<AdConfig>;
}

export interface CompanionParam {
  __typename?: 'CompanionParam';
  delayShowClose?: Maybe<Delay>;
}

export interface ConcurrentUsers {
  __typename?: 'ConcurrentUsers';
  count?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
}

export interface ConfirmRegistrationInput {
  code: Scalars['String'];
  type: RegistrationType;
  value: Scalars['String'];
}

export interface Content {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface ContentDetailFilter {
  age?: InputMaybe<Scalars['Int']>;
  ageGroup?: InputMaybe<Scalars['String']>;
  appVersion?: InputMaybe<Scalars['String']>;
  bdSource?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['String']>;
  checkParentalControl: Scalars['Boolean'];
  contentId?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  currentParentalControl?: InputMaybe<Scalars['String']>;
  dekey?: InputMaybe<Scalars['String']>;
  deviceId: Scalars['String'];
  gender?: InputMaybe<Scalars['String']>;
  isAvailableOnSugarBox?: InputMaybe<Scalars['String']>;
  isLatest?: InputMaybe<Scalars['String']>;
  isMarketing?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  platformName: Scalars['String'];
  showId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  sugarBoxDrmKey?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  userLanguage?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
}

export interface ContentFilter {
  country?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
}

export interface ContentMetaData {
  actors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ageRating?: Maybe<Scalars['String']>;
  assetSubType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['Int']>;
  audioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingType?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  genres?: Maybe<Array<Maybe<KeyValuePair>>>;
  image?: Maybe<Image>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  releaseDate?: Maybe<Scalars['String']>;
  subtitleLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface ContentPartner {
  __typename?: 'ContentPartner';
  deeplinkUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ContentPartnerImage>;
  name?: Maybe<Scalars['String']>;
}

export interface ContentPartnerImage {
  __typename?: 'ContentPartnerImage';
  circleDarkLogo?: Maybe<Scalars['String']>;
  circleWhiteLogo?: Maybe<Scalars['String']>;
  purchaseImage?: Maybe<Scalars['String']>;
  rectangleDarkLogo?: Maybe<Scalars['String']>;
  rectangleWhiteLogo?: Maybe<Scalars['String']>;
}

export interface ContentWatchHistory {
  __typename?: 'ContentWatchHistory';
  id?: Maybe<Scalars['String']>;
  playedDate?: Maybe<Scalars['String']>;
  playedDuration?: Maybe<Scalars['Int']>;
}

export interface Contestant extends Content {
  __typename?: 'Contestant';
  age?: Maybe<Scalars['Int']>;
  assetSubType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  deeplinkUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  lastName?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  rankingPosition?: Maybe<Scalars['String']>;
  relatedCollectionId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
  tvshowId?: Maybe<Scalars['String']>;
}

export enum ContestantSortBy {
  Name = 'Name',
  Rank = 'Rank'
}

export enum ContestantSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export interface CursorFeed {
  __typename?: 'CursorFeed';
  data?: Maybe<Array<Maybe<FeedItem>>>;
  nextCursorId?: Maybe<Scalars['String']>;
}

export interface Delay {
  __typename?: 'Delay';
  closeDelay?: Maybe<Scalars['Int']>;
  hideOnEndCard?: Maybe<Scalars['Boolean']>;
  showDelay?: Maybe<Scalars['Int']>;
}

export interface Device {
  __typename?: 'Device';
  appName?: Maybe<Scalars['String']>;
  appVersion?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  loggedInTime?: Maybe<Scalars['String']>;
  loggedOutTime?: Maybe<Scalars['String']>;
  osName?: Maybe<Scalars['String']>;
  platformName?: Maybe<Scalars['String']>;
  platformVersion?: Maybe<Scalars['String']>;
  /**
   * currently these fields are not needed
   * playerCapabilities : PlayerCapability
   * securityCapabilities : SecurityCapability
   */
  registrationCity?: Maybe<Scalars['String']>;
  registrationCountry?: Maybe<Scalars['String']>;
  registrationState?: Maybe<Scalars['String']>;
  schemaVersion?: Maybe<Scalars['String']>;
}

export interface DeviceCode {
  __typename?: 'DeviceCode';
  deviceCode: Scalars['String'];
}

export interface Dimension {
  __typename?: 'Dimension';
  height?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
}

export interface Discount {
  __typename?: 'Discount';
  discountAmount?: Maybe<Scalars['Float']>;
  discountCode?: Maybe<Scalars['String']>;
  discountPercentage?: Maybe<Scalars['Float']>;
}

export interface DisplayAds {
  __typename?: 'DisplayAds';
  betweenRail?: Maybe<Array<Maybe<DisplayAdsMetaData>>>;
  endCard?: Maybe<Array<Maybe<DisplayAdsMetaData>>>;
  nextToPlayer?: Maybe<Array<Maybe<DisplayAdsMetaData>>>;
  overlayPlayer?: Maybe<Array<Maybe<DisplayAdsMetaData>>>;
}

export interface DisplayAdsMetaData {
  __typename?: 'DisplayAdsMetaData';
  position?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
}

export interface Education {
  __typename?: 'Education';
  background?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  career?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  education?: Maybe<Scalars['String']>;
  trivia?: Maybe<Scalars['String']>;
}

export interface Entitlement {
  __typename?: 'Entitlement';
  isAVOD?: Maybe<Scalars['Boolean']>;
  isAdAuthenticated?: Maybe<Scalars['Boolean']>;
  isBeforeTv?: Maybe<Scalars['Boolean']>;
  isDai?: Maybe<Scalars['Boolean']>;
  isLive?: Maybe<Scalars['Boolean']>;
  isPremiumPlayback?: Maybe<Scalars['Boolean']>;
  isTVOD?: Maybe<Scalars['Boolean']>;
  isTrailer?: Maybe<Scalars['Boolean']>;
}

export interface Episode extends Content, ContentMetaData {
  __typename?: 'Episode';
  actors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ageRating?: Maybe<Scalars['String']>;
  assetSubType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['Int']>;
  audioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingType?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  clickID?: Maybe<Scalars['String']>;
  contentDescriptors?: Maybe<Array<Maybe<Scalars['String']>>>;
  contentOwner?: Maybe<Scalars['String']>;
  contentPartner?: Maybe<ContentPartner>;
  extended?: Extended;
  contentPartnerAssetId?: Maybe<Scalars['String']>;
  contentPartnerDetails?: Maybe<ContentPartner>;
  contentType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  directors?: Maybe<Array<Maybe<Scalars['String']>>>;
  drmKey?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  episodeNumber?: Maybe<Scalars['Int']>;
  eventDetail?: Maybe<Scalars['String']>;
  eventLive?: Maybe<Scalars['Boolean']>;
  eventStartDate?: Maybe<Scalars['String']>;
  eventTimeLine?: Maybe<Scalars['String']>;
  genres?: Maybe<Array<Maybe<KeyValuePair>>>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  imageType?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Image>;
  imdbRating?: Maybe<Scalars['Float']>;
  introEndTime?: Maybe<Scalars['String']>;
  introStartTime?: Maybe<Scalars['String']>;
  isAddedToWatchList?: Maybe<Scalars['Boolean']>;
  isDrm?: Maybe<Scalars['Int']>;
  isLiked?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  matchScore?: Maybe<Scalars['Int']>;
  onAir?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  origin?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  overlayImageCircleDark?: Maybe<OverlayImage>;
  overlayImageCircleWhite?: Maybe<OverlayImage>;
  overlayImagePurchaseImage?: Maybe<OverlayImage>;
  overlayImageRectangleDark?: Maybe<OverlayImage>;
  overlayImageRectangleWhite?: Maybe<OverlayImage>;
  parentAsset?: Maybe<KeyValuePair>;
  playDate?: Maybe<Scalars['String']>;
  playedDuration?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  releaseDate?: Maybe<Scalars['String']>;
  searchRelevanceInfo?: Maybe<SearchRelevanceInfo>;
  seasonAndEpisode?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  socialMediaReviews?: Maybe<Array<Maybe<SocialMediaReviews>>>;
  subtitleLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  thumbnails?: Maybe<Array<Maybe<Image>>>;
  tier?: Maybe<Scalars['String']>;
  timeLeft?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topContentPosition?: Maybe<Scalars['Int']>;
  tvShow?: Maybe<TvShowFragment>;
  tvShowImage?: Maybe<Image>;
  upcomingContent?: Maybe<Scalars['String']>;
  video?: Maybe<Video>;
  videoUri?: Maybe<Video>;
  viewCount?: Maybe<ViewCount>;
  webSlug?: Maybe<Scalars['String']>;
  webUrl?: Maybe<Scalars['String']>;
}

export interface EpisodeFilter {
  assetSubType?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  itemType: EpisodeType;
  languages?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['String']>;
  onAir?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<Scalars['String']>;
  seasonId: Scalars['String'];
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
}

export enum EpisodeType {
  Clip = 'clip',
  Episode = 'episode',
  Mobisode = 'mobisode',
  Preview = 'preview',
  Promo = 'promo',
  Trailer = 'trailer',
  Webisode = 'webisode'
}

export interface Error {
  __typename?: 'Error';
  code?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Maybe<ErrorField>>>;
  message?: Maybe<Scalars['String']>;
  userDisplayMessage?: Maybe<Scalars['String']>;
}

export enum ErrorDetail {
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests or 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm = 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound = 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument = 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor = 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource = 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError = 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure = 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency = 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu = 'THROTTLED_CPU',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented = 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown = 'UNKNOWN'
}

export interface ErrorField {
  __typename?: 'ErrorField';
  field?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
}

export enum ErrorType {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest = 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition = 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal = 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NotFound = 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied = 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated = 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable = 'UNAVAILABLE',
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown = 'UNKNOWN'
}

export interface ExtendedAssetDetail {
  __typename?: 'ExtendedAssetDetail';
  adMarker?: Maybe<Scalars['String']>;
  broadcastState?: Maybe<Scalars['String']>;
  contentDescriptors?: Maybe<Array<Maybe<Scalars['String']>>>;
  decorationName?: Maybe<Scalars['String']>;
  musicDirectors?: Maybe<Array<Maybe<Scalars['String']>>>;
  productionCompany?: Maybe<Scalars['String']>;
  productionDesign?: Maybe<Scalars['String']>;
  seoContentBlock?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoRedirectionType?: Maybe<Scalars['String']>;
  seoRedirectionLink?: Maybe<Scalars['String']>;
  metaKeywords?: Maybe<Scalars['String']>;
  seoNoIndex?: Maybe<Scalars['Boolean']>;
  seoNoFollow?: Maybe<Scalars['Boolean']>;
  canonicalUrl?: Maybe<Scalars['String']>;
  seoUrlStructure?: Maybe<Scalars['String']>;
}

export interface ExtraRun {
  __typename?: 'ExtraRun';
  byes?: Maybe<Scalars['Int']>;
  legByes?: Maybe<Scalars['Int']>;
  noBalls?: Maybe<Scalars['Int']>;
  penalty?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  wides?: Maybe<Scalars['Int']>;
}

export interface Family {
  __typename?: 'Family';
  children?: Maybe<Array<Maybe<FamilyMemberDetails>>>;
  father?: Maybe<FamilyMemberDetails>;
  maritalStatus?: Maybe<FamilyMemberDetails>;
  mother?: Maybe<FamilyMemberDetails>;
  spouse?: Maybe<FamilyMemberDetails>;
}

export interface FamilyMemberDetails {
  __typename?: 'FamilyMemberDetails';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  seoId?: Maybe<Scalars['String']>;
}

export interface Feature {
  __typename?: 'Feature';
  id?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface FeatureMetaData {
  __typename?: 'FeatureMetaData';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<MetaDataValue>;
}

export type FeedItem = Commentary | KeyMoment;

export interface ForYouQueryInRailInput {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
}

export interface ForYouRailResultsInput {
  ageRating?: InputMaybe<Scalars['Int']>;
  assetId?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['String'];
  languages?: InputMaybe<Scalars['String']>;
  modelVersion?: InputMaybe<Scalars['Int']>;
  state: Scalars['String'];
  translation?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
}

export interface ForYouResultInRail {
  __typename?: 'ForYouResultInRail';
  aiSuggestionRailPosition?: Maybe<Scalars['Int']>;
  continueWatchRailPosition?: Maybe<Scalars['Int']>;
  rails?: Maybe<Array<Maybe<Rail>>>;
  status?: Maybe<Array<Maybe<Scalars['String']>>>;
  total?: Maybe<Scalars['Int']>;
  watchListRailPosition?: Maybe<Scalars['Int']>;
}

export interface ForgotPasswordInput {
  type: LoginType;
  value: Scalars['String'];
}

export interface GameMetaData {
  __typename?: 'GameMetaData';
  assetId?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  pointsForCorrectAnswer?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tournamentId?: Maybe<Scalars['String']>;
}

export enum GameType {
  Antakshari = 'ANTAKSHARI',
  AuditionQuiz = 'AUDITION_QUIZ',
  Houzee = 'HOUZEE',
  PredictAndWin = 'PREDICT_AND_WIN'
}

export interface GenAiSearchLandingInput {
  city?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  languages?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface GenAiSearchLandingRail {
  __typename?: 'GenAiSearchLandingRail';
  rails?: Maybe<Array<Maybe<Rail>>>;
  status?: Maybe<Array<Maybe<Scalars['String']>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface Genre {
  __typename?: 'Genre';
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  value: Scalars['String'];
}

export interface GenreFilter {
  country: Scalars['String'];
  translation?: InputMaybe<Scalars['String']>;
}

export interface GenreOrLanguageFilter {
  assetSubType: AssetSubType;
  country: Scalars['String'];
  genre?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
}

export interface GradientColor {
  __typename?: 'GradientColor';
  bottomColor?: Maybe<Color>;
  endPointX?: Maybe<Scalars['Float']>;
  endPointY?: Maybe<Scalars['Float']>;
  startPointX?: Maybe<Scalars['Float']>;
  startPointY?: Maybe<Scalars['Float']>;
  topColor?: Maybe<Color>;
}

export interface GuestUser {
  __typename?: 'GuestUser';
  accessToken: Scalars['String'];
  id: Scalars['ID'];
}

export interface Hipi extends Content, ContentMetaData {
  __typename?: 'Hipi';
  actors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ageRating?: Maybe<Scalars['String']>;
  assetSubType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['Int']>;
  audioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingType?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  contentOwner?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  drmKey?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  genres?: Maybe<Array<Maybe<KeyValuePair>>>;
  id: Scalars['String'];
  image?: Maybe<Image>;
  imageUrl?: Maybe<Array<Maybe<Scalars['String']>>>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  originalTitle?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  subtitleLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
}

export interface HipiFilter {
  collectionId: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface Image {
  __typename?: 'Image';
  appCover?: Maybe<Scalars['String']>;
  appSvodCover?: Maybe<Scalars['String']>;
  banner4k?: Maybe<Scalars['String']>;
  channelList?: Maybe<Scalars['String']>;
  channelSquare?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['String']>;
  desktopBanner?: Maybe<Scalars['String']>;
  list?: Maybe<Scalars['String']>;
  listClean?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mainThumbnail?: Maybe<Scalars['String']>;
  mobileBanner?: Maybe<Scalars['String']>;
  portrait?: Maybe<Scalars['String']>;
  portraitClean?: Maybe<Scalars['String']>;
  square?: Maybe<Scalars['String']>;
  sticker?: Maybe<Scalars['String']>;
  svodCover?: Maybe<Scalars['String']>;
  tvCover?: Maybe<Scalars['String']>;
  verticalBanner?: Maybe<Scalars['String']>;
}

export interface Innings {
  __typename?: 'Innings';
  battingTable?: Maybe<BattingTable>;
  battingTeamId?: Maybe<Scalars['String']>;
  bowlingTable?: Maybe<BowlingTable>;
  bowlingTeamId?: Maybe<Scalars['String']>;
  equations?: Maybe<InningsEquations>;
  extras?: Maybe<ExtraRun>;
  fullScore?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['String']>;
  shortTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  wickets?: Maybe<Array<Maybe<Wicket>>>;
  yetToBat?: Maybe<Array<Maybe<YetToBat>>>;
}

export interface InningsEquations {
  __typename?: 'InningsEquations';
  bowlersUsed?: Maybe<Scalars['String']>;
  overs?: Maybe<Scalars['String']>;
  runRate?: Maybe<Scalars['String']>;
  runs?: Maybe<Scalars['String']>;
  wickets?: Maybe<Scalars['String']>;
}

export interface InterstitialAdConfig {
  __typename?: 'InterstitialAdConfig';
  appExitAdTag?: Maybe<Scalars['String']>;
  guestUserAdVisibility?: Maybe<AdVisibility>;
  premiumUserAdVisibility?: Maybe<AdVisibility>;
  registeredUserAdVisibility?: Maybe<AdVisibility>;
  splashAdTag?: Maybe<Scalars['String']>;
  videoAdTag?: Maybe<Scalars['String']>;
  videoViewCount?: Maybe<Scalars['Int']>;
  videoViewDuration?: Maybe<Scalars['Int']>;
}

export interface ItemDetails {
  __typename?: 'ItemDetails';
  contentImageUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

export interface JusPayProcessOrderDetails {
  __typename?: 'JusPayProcessOrderDetails';
  planDescription?: Maybe<Scalars['String']>;
  planTitle?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
}

export interface JusPayProcessOrderInput {
  actionType?: InputMaybe<Scalars['String']>;
  actualValue?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  feDomain?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  oldPackId?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  rsvodPackId?: InputMaybe<Scalars['String']>;
  subscriptionPlanId?: InputMaybe<Scalars['String']>;
}

export interface KeyMoment {
  __typename?: 'KeyMoment';
  assetId?: Maybe<Scalars['String']>;
  delivery?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  outcomeType?: Maybe<Scalars['String']>;
  thumbnailId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface KeyOsDetail {
  __typename?: 'KeyOsDetail';
  assetKey?: Maybe<Scalars['String']>;
  dashDrmAssetKey?: Maybe<Scalars['String']>;
  drm?: Maybe<Scalars['String']>;
  hlsToken?: Maybe<Scalars['String']>;
  oneTimeSecurityKey?: Maybe<Scalars['String']>;
  streamLanguage?: Maybe<Scalars['String']>;
  videoToken?: Maybe<Scalars['String']>;
}

export interface KeyValuePair {
  __typename?: 'KeyValuePair';
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

export interface KeyValuePairList {
  __typename?: 'KeyValuePairList';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface Language {
  __typename?: 'Language';
  code?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  value: Scalars['String'];
}

export interface LeaderBoard {
  __typename?: 'LeaderBoard';
  leaderboard?: Maybe<Array<Maybe<PlayerStanding>>>;
}

export interface LeaderBoardPlayer {
  __typename?: 'LeaderBoardPlayer';
  city?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
}

export interface LiveTvChannel extends Content, ContentMetaData {
  __typename?: 'LiveTvChannel';
  actors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ageRating?: Maybe<Scalars['String']>;
  assetSubType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['Int']>;
  audioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingType?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelId>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['String']>;
  genres?: Maybe<Array<Maybe<KeyValuePair>>>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  originalTitle?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  subtitleLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
}

export enum LoginType {
  Email = 'EMAIL',
  Mobile = 'MOBILE'
}

export interface LogoutResponse {
  __typename?: 'LogoutResponse';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
}

export interface Match extends Content {
  __typename?: 'Match';
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  matchHighlightId?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  sportsType?: Maybe<SportsType>;
  startDate?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['String']>;
  status?: Maybe<MatchStatus>;
  statusNote?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  /** Should it be teamA teamB or teams array which has two teams?? */
  teamA?: Maybe<TeamScore>;
  teamB?: Maybe<TeamScore>;
  title?: Maybe<Scalars['String']>;
  toss?: Maybe<Toss>;
  tournamentId?: Maybe<Scalars['String']>;
  venue?: Maybe<MatchVenue>;
}

export enum MatchStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Live = 'Live',
  Scheduled = 'Scheduled'
}

export interface MatchVenue {
  __typename?: 'MatchVenue';
  country?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

export interface MetaData {
  __typename?: 'MetaData';
  poweredByLogo?: Maybe<Array<Maybe<AttributeKeyValuePair>>>;
}

export interface MetaDataValue {
  __typename?: 'MetaDataValue';
  isAvailable?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface Movie extends Content, ContentMetaData {
  __typename?: 'Movie';
  actors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ageRating?: Maybe<Scalars['String']>;
  assetSubType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['Int']>;
  audioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingType?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  clickID?: Maybe<Scalars['String']>;
  contentDescriptors?: Maybe<Array<Maybe<Scalars['String']>>>;
  contentOwner?: Maybe<Scalars['String']>;
  contentPartner?: Maybe<ContentPartner>;
  contentPartnerAssetId?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  drmKey?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  eventLive?: Maybe<Scalars['Boolean']>;
  genres?: Maybe<Array<Maybe<KeyValuePair>>>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  imageType?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Image>;
  imdbRating?: Maybe<Scalars['Float']>;
  introEndTime?: Maybe<Scalars['String']>;
  introStartTime?: Maybe<Scalars['String']>;
  isAddedToWatchList?: Maybe<Scalars['Boolean']>;
  isDrm?: Maybe<Scalars['Int']>;
  isLiked?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  matchScore?: Maybe<Scalars['Int']>;
  onAir?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  overlayImageCircleDark?: Maybe<OverlayImage>;
  overlayImageCircleWhite?: Maybe<OverlayImage>;
  overlayImagePurchaseImage?: Maybe<OverlayImage>;
  overlayImageRectangleDark?: Maybe<OverlayImage>;
  overlayImageRectangleWhite?: Maybe<OverlayImage>;
  parentAsset?: Maybe<KeyValuePair>;
  playDate?: Maybe<Scalars['String']>;
  playedDuration?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  relatedContentIds?: Maybe<Array<Maybe<RelatedContentId>>>;
  releaseDate?: Maybe<Scalars['String']>;
  searchRelevanceInfo?: Maybe<SearchRelevanceInfo>;
  seoTitle?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  socialMediaReviews?: Maybe<Array<Maybe<SocialMediaReviews>>>;
  subtitleLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  thumbnails?: Maybe<Array<Maybe<Image>>>;
  tier?: Maybe<Scalars['String']>;
  timeLeft?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topContentPosition?: Maybe<Scalars['Int']>;
  video?: Maybe<Video>;
  videoUri?: Maybe<Video>;
  viewCount?: Maybe<ViewCount>;
  webUrl?: Maybe<Scalars['String']>;
}

export interface MovieByActorsFilter {
  actors: Scalars['String'];
  actorsType: Scalars['String'];
  assetSubType?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  version: Scalars['String'];
}

export interface MovieFilter {
  assetSubType?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
}

export interface Mutation {
  __typename?: 'Mutation';
  /** Mandatory Header - 'x-access-token', 'authorization' */
  addToWatchHistory?: Maybe<UpdationResponse>;
  addToWatchList?: Maybe<UpdationResponse>;
  addToWatchListBasedOnProfile?: Maybe<UpdationResponse>;
  /** Confirm Email/Mobile used for Registration: Mandatory Headers - 'device_id', 'esk' */
  confirmRegistration?: Maybe<UpdationResponse>;
  createPromotionalSubscription?: Maybe<UserSubscription>;
  createWatchPartyRoom?: Maybe<WatchPartyRoom>;
  deleteFromWatchHistory?: Maybe<UpdationResponse>;
  deleteFromWatchList?: Maybe<UpdationResponse>;
  deleteFromWatchListBasedOnProfile?: Maybe<UpdationResponse>;
  /** Delete User Settings : Mandatory Headers - 'authorization', 'device_id', 'esk' */
  deleteUserSettings?: Maybe<UpdationResponse>;
  generateZucasaToken?: Maybe<ZucasaToken>;
  logoutDevice?: Maybe<LogoutResponse>;
  /** Process Juspay order : Header - 'x-access-token', 'authorization' */
  processJusPayOrder: JusPayProcessOrderDetails;
  /** Recreate password with code and Email/Mobile : Mandatory Headers - 'device_id', 'esk' */
  recreatePassword?: Maybe<UpdationResponse>;
  registerUserToGamification?: Maybe<UserRegisterResponse>;
  submitAnswer?: Maybe<AnswerResponse>;
  submitPollResponse?: Maybe<PollResponse>;
  /** User Registration Facebook/Google/Twitter : Mandatory Headers - 'device_id', 'esk' */
  thirdPartyRegistration?: Maybe<Tokens>;
  /** Truecaller Android Register Login : Mandatory Headers - 'device_id', 'esk' */
  trueCallerAndroidRegisterLogin?: Maybe<Tokens>;
  /** Truecaller Android Register User : Mandatory Headers - 'device_id', 'esk' */
  trueCallerAndroidRegisterUser?: Maybe<Tokens>;
  /** Truecaller Android Update : Mandatory Headers - 'device_id', 'esk' */
  trueCallerAndroidUpdate?: Maybe<Tokens>;
  /** Truecaller Merge : Mandatory Headers - 'device_id', 'esk' */
  trueCallerMerge?: Maybe<Tokens>;
  /** Update/Change Password : Mandatory Headers - 'authorization', 'device_id', 'esk' */
  updatePassword?: Maybe<UpdationResponse>;
  /** Update User Details : Mandatory Headers - 'authorization', 'device_id', 'esk' */
  updateUserDetails?: Maybe<UpdationResponse>;
  /** Set/Update User Settings : Mandatory Headers - 'authorization', 'device_id', 'esk' */
  updateUserSettings?: Maybe<Array<UpdationResponse>>;
  updateWatchHistory?: Maybe<UpdationResponse>;
  /** User Registration Email/Mobile : Mandatory Headers - 'device_id', 'esk' */
  userRegistration?: Maybe<UpdationResponse>;
}

export interface MutationAddToWatchHistoryArgs {
  input: WatchHistoryInput;
}

export interface MutationAddToWatchListArgs {
  input: WatchListInput;
}

export interface MutationAddToWatchListBasedOnProfileArgs {
  input: WatchListInput;
  profileId: Scalars['String'];
}

export interface MutationConfirmRegistrationArgs {
  confirmRegistrationInput: ConfirmRegistrationInput;
}

export interface MutationCreatePromotionalSubscriptionArgs {
  token: Scalars['String'];
}

export interface MutationDeleteFromWatchHistoryArgs {
  assetType: Scalars['Int'];
  id: Scalars['String'];
}

export interface MutationDeleteFromWatchListArgs {
  assetType: Scalars['Int'];
  id: Scalars['String'];
}

export interface MutationDeleteFromWatchListBasedOnProfileArgs {
  assetType: Scalars['Int'];
  id: Scalars['String'];
  profileId: Scalars['String'];
}

export interface MutationDeleteUserSettingsArgs {
  settingKey?: InputMaybe<Scalars['String']>;
}

export interface MutationGenerateZucasaTokenArgs {
  input: ZucasaUserInput;
}

export interface MutationLogoutDeviceArgs {
  deviceIds: Array<Scalars['String']>;
}

export interface MutationProcessJusPayOrderArgs {
  jusPayProcessOrderInput: JusPayProcessOrderInput;
}

export interface MutationRecreatePasswordArgs {
  recreatePasswordInput: RecreatePasswordInput;
}

export interface MutationRegisterUserToGamificationArgs {
  region?: InputMaybe<Scalars['String']>;
  userName: Scalars['String'];
}

export interface MutationSubmitAnswerArgs {
  submitAnswerInput: SubmitAnswerInput;
}

export interface MutationSubmitPollResponseArgs {
  data?: InputMaybe<SubmitPollResponseInput>;
}

export interface MutationThirdPartyRegistrationArgs {
  thirdPartyRegistrationInput: ThirdPartyRegistrationInput;
}

export interface MutationTrueCallerAndroidRegisterLoginArgs {
  trueCallerAndroidUpdateInput: TrueCallerAndroidUpdateInput;
}

export interface MutationTrueCallerAndroidRegisterUserArgs {
  trueCallerAndroidRegisterUserInput: TrueCallerAndroidRegisterUserInput;
}

export interface MutationTrueCallerAndroidUpdateArgs {
  trueCallerAndroidUpdateInput: TrueCallerAndroidUpdateInput;
}

export interface MutationTrueCallerMergeArgs {
  trueCallerMergeInput: TrueCallerMergeInput;
}

export interface MutationUpdatePasswordArgs {
  updatePasswordInput: UpdatePasswordInput;
}

export interface MutationUpdateUserDetailsArgs {
  updateUserDetailsInput: UpdateUserDetailsInput;
}

export interface MutationUpdateUserSettingsArgs {
  action?: InputMaybe<Action>;
  userSettings?: InputMaybe<Array<InputMaybe<UserSettingsInput>>>;
}

export interface MutationUpdateWatchHistoryArgs {
  input: WatchHistoryInput;
}

export interface MutationUserRegistrationArgs {
  userRegistrationInput: UserRegistrationInput;
}

export interface NetWorth {
  __typename?: 'NetWorth';
  netWorth?: Maybe<Scalars['Int']>;
}

export interface Offer {
  __typename?: 'Offer';
  amount?: Maybe<Scalars['Float']>;
  mainPlanId?: Maybe<Scalars['String']>;
  mainPlanTransactionId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface OpinionPollPercentage {
  __typename?: 'OpinionPollPercentage';
  aggregatePercentage?: Maybe<Scalars['Int']>;
  isUserSelectedOption?: Maybe<Scalars['Boolean']>;
  optionId?: Maybe<Scalars['String']>;
}

export interface OpinionPollResponse {
  __typename?: 'OpinionPollResponse';
  pollPercentages?: Maybe<Array<Maybe<OpinionPollPercentage>>>;
  questionId?: Maybe<Scalars['String']>;
}

export interface OptionResponse {
  __typename?: 'OptionResponse';
  id?: Maybe<Scalars['String']>;
  optionText?: Maybe<Scalars['String']>;
}

export interface OverlayImage {
  __typename?: 'OverlayImage';
  appCover?: Maybe<Scalars['String']>;
  banner4k?: Maybe<Scalars['String']>;
  channelList?: Maybe<Scalars['String']>;
  channelSquare?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['String']>;
  desktopBanner?: Maybe<Scalars['String']>;
  list?: Maybe<Scalars['String']>;
  listClean?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mobileBanner?: Maybe<Scalars['String']>;
  portrait?: Maybe<Scalars['String']>;
  square?: Maybe<Scalars['String']>;
  sticker?: Maybe<Scalars['String']>;
  svodCover?: Maybe<Scalars['String']>;
  verticalBanner?: Maybe<Scalars['String']>;
}

export interface Pagination {
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  totalResults?: Maybe<Scalars['Int']>;
}

/** TODO: Rename it to Pagination */
export interface PaginationCommon {
  currentPageIndex?: Maybe<Scalars['Int']>;
  currentResultsCount?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  totalResultsCount?: Maybe<Scalars['Int']>;
}

export interface Partner {
  __typename?: 'Partner';
  partnerConfig?: Maybe<PartnerConfig>;
  partnerId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
}

export interface PartnerConfig {
  __typename?: 'PartnerConfig';
  allowChangePassword?: Maybe<Scalars['Boolean']>;
  allowChromeCast?: Maybe<Scalars['Boolean']>;
  backToPartnerConfig?: Maybe<BackToPartnerConfig>;
  blockerScreenConfig?: Maybe<BlockerScreenConfig>;
  havePrepaidCode?: Maybe<Scalars['Boolean']>;
  isPartnerActive?: Maybe<Scalars['Boolean']>;
  shouldAuthenticateDevice?: Maybe<Scalars['Boolean']>;
  showBackToPartner?: Maybe<Scalars['Boolean']>;
  showBlockerScreen?: Maybe<Scalars['Boolean']>;
  showBuySubscription?: Maybe<Scalars['Boolean']>;
  showLogout?: Maybe<Scalars['Boolean']>;
  showMyProfile?: Maybe<Scalars['Boolean']>;
  showMySubscriptions?: Maybe<Scalars['Boolean']>;
  showMyTransactions?: Maybe<Scalars['Boolean']>;
}

export interface PartnerSettingPrimaryCta {
  __typename?: 'PartnerSettingPrimaryCta';
  androidDeepLink?: Maybe<Scalars['String']>;
  androidPartnerDeepLink?: Maybe<Scalars['String']>;
  deepLink?: Maybe<Scalars['String']>;
  iosDeepLink?: Maybe<Scalars['String']>;
  iosPartnerDeepLink?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  viServiceAndroidDeepLink?: Maybe<Scalars['String']>;
  viServiceAndroidPartnerDeepLink?: Maybe<Scalars['String']>;
  viServiceDeepLink?: Maybe<Scalars['String']>;
  viServiceIosDeepLink?: Maybe<Scalars['String']>;
  viServiceIosPartnerDeepLink?: Maybe<Scalars['String']>;
  viServiceWebLink?: Maybe<Scalars['String']>;
  webLink?: Maybe<Scalars['String']>;
}

export interface PartnerSettings {
  __typename?: 'PartnerSettings';
  partner?: Maybe<Partner>;
  partnerKey?: Maybe<Scalars['String']>;
}

export interface PaymentProvider {
  __typename?: 'PaymentProvider';
  name?: Maybe<Scalars['String']>;
  productReference?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
}

export interface Plan {
  __typename?: 'Plan';
  actualPrice?: Maybe<Scalars['Float']>;
  allowedPlaybackDuration?: Maybe<Scalars['Int']>;
  billingCycleType?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['Int']>;
  billingType?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  contentPartnerDetails?: Maybe<Array<Maybe<ContentPartner>>>;
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Discount>;
  displayPrice?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  featureMetadata?: Maybe<Array<Maybe<FeatureMetaData>>>;
  freeTrial?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isPurchaseAllowed?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  numOfSupportedDevices?: Maybe<Scalars['Int']>;
  originalTitle?: Maybe<Scalars['String']>;
  paymentProviders?: Maybe<Array<Maybe<PaymentProvider>>>;
  planType?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  sellPrice?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['String']>;
  suggestionTag?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface PlanDetail {
  __typename?: 'PlanDetail';
  defaultPlan?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<Feature>>>;
  plans?: Maybe<Array<Maybe<Plan>>>;
}

export interface Player {
  __typename?: 'Player';
  country?: Maybe<Scalars['String']>;
  countryFlagImageUrl?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  playerAttributes?: Maybe<Array<Maybe<AttributeKeyValuePair>>>;
  title?: Maybe<Scalars['String']>;
}

export interface PlayerCapability {
  __typename?: 'PlayerCapability';
  audioChannel?: Maybe<Array<Maybe<Scalars['String']>>>;
  container?: Maybe<Array<Maybe<Scalars['String']>>>;
  dynamicRange?: Maybe<Array<Maybe<Scalars['String']>>>;
  packageDetails?: Maybe<Array<Maybe<Scalars['String']>>>;
  resolution?: Maybe<Array<Maybe<Scalars['String']>>>;
  videoCodec?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface PlayerReward {
  __typename?: 'PlayerReward';
  createdAt?: Maybe<Scalars['Int']>;
  expiryDate?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  gameType?: Maybe<GameType>;
  id?: Maybe<Scalars['String']>;
  milestoneName?: Maybe<Scalars['String']>;
  playerId?: Maybe<Scalars['String']>;
  playerRewardStatus?: Maybe<Scalars['String']>;
  rewardInfo?: Maybe<Rewards>;
}

export interface PlayerStanding {
  __typename?: 'PlayerStanding';
  avatarUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  playerName?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Int']>;
  rewardItem?: Maybe<Scalars['String']>;
}

export interface PlayersByCategory {
  __typename?: 'PlayersByCategory';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Array<Maybe<Player>>>;
}

export interface PointsTable extends Content {
  __typename?: 'PointsTable';
  columns?: Maybe<Array<Maybe<TableColumns>>>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  rows?: Maybe<Array<Maybe<PointsTableRow>>>;
  seasonId?: Maybe<Scalars['String']>;
  sportsType?: Maybe<SportsType>;
  title?: Maybe<Scalars['String']>;
  tournamentId?: Maybe<Scalars['String']>;
}

export interface PointsTableRow {
  __typename?: 'PointsTableRow';
  lost?: Maybe<Scalars['String']>;
  netRunRate?: Maybe<Scalars['String']>;
  noResults?: Maybe<Scalars['String']>;
  played?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['String']>;
  team?: Maybe<Team>;
  won?: Maybe<Scalars['String']>;
}

export interface PolicyFields {
  age?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['String']>;
  profiling?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Scalars['String']>;
}

export interface Poll {
  __typename?: 'Poll';
  assetId?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pollQuestions?: Maybe<Array<Maybe<PollQuestion>>>;
  pollTimer?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['String']>;
  viewPollAudienceType?: Maybe<Scalars['String']>;
  viewResultAudienceType?: Maybe<Scalars['String']>;
}

export interface PollOption {
  __typename?: 'PollOption';
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isOptionCorrect?: Maybe<Scalars['Boolean']>;
  optionType?: Maybe<Scalars['String']>;
  originalContent?: Maybe<Scalars['String']>;
}

export interface PollQuestion {
  __typename?: 'PollQuestion';
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  opinionPollResponse?: Maybe<OpinionPollResponse>;
  originalContent?: Maybe<Scalars['String']>;
  pollOptions?: Maybe<Array<Maybe<PollOption>>>;
  userResponse?: Maybe<UserResponse>;
}

export interface PollResponse {
  __typename?: 'PollResponse';
  category?: Maybe<Scalars['String']>;
  isOptionCorrect?: Maybe<Scalars['Boolean']>;
  pollId?: Maybe<Scalars['String']>;
  pollPercentages?: Maybe<Array<Maybe<OpinionPollPercentage>>>;
  questionId?: Maybe<Scalars['String']>;
  selectedOptionId?: Maybe<Scalars['String']>;
}

export interface PrepaidCodeVerificationDetails {
  __typename?: 'PrepaidCodeVerificationDetails';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
}

export interface PrepaidCodeVerificationInput {
  countryCode: Scalars['String'];
  couponCode: Scalars['String'];
  translation: Scalars['String'];
}

export interface ProgramGuideFilter {
  /** Comma separated String of Channel IDs */
  channels: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  endDay?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  /** 0 for Current Day, 1 for Next Day and so on */
  startDay?: InputMaybe<Scalars['Int']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface Promotion {
  __typename?: 'Promotion';
  code?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  discountType?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  freeTrialWithPromotionAllowed?: Maybe<Scalars['Boolean']>;
  multipleUsageAllowed?: Maybe<Scalars['Boolean']>;
  numberOfBillingCycles?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['String']>;
  targetUsers?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface PromotionalData {
  on?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
}

export interface PromptSuggestionByCategory {
  __typename?: 'PromptSuggestionByCategory';
  category?: Maybe<PromptSuggestionResult>;
}

export interface PromptSuggestionResponse {
  __typename?: 'PromptSuggestionResponse';
  categoryName?: Maybe<Scalars['String']>;
  gradientColor?: Maybe<GradientColor>;
  imageUrl?: Maybe<Scalars['String']>;
  prompts?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface PromptSuggestionResult {
  __typename?: 'PromptSuggestionResult';
  floatingText?: Maybe<Array<Maybe<Scalars['String']>>>;
  hybridSearch?: Maybe<Array<Maybe<PromptSuggestionResponse>>>;
}

export interface PromptSuggestions {
  __typename?: 'PromptSuggestions';
  defaultPrompts?: Maybe<Array<Maybe<KeyValuePairList>>>;
  promptsByCategory?: Maybe<Array<Maybe<KeyValuePairList>>>;
}

export interface Query {
  __typename?: 'Query';
  _service: _Service;
  adStacks?: Maybe<ClcVideo>;
  /** User Amazon Login : Mandatory Headers - 'device_id', 'esk' */
  amazonLogin?: Maybe<Tokens>;
  campaignLeaderBoard?: Maybe<LeaderBoard>;
  /** Get cart abandonment details : Header - 'x-access-token', 'authorization' */
  cartAbandonmentDetails: CartAbandonmentDetails;
  celebrityDetails?: Maybe<CelebrityDetails>;
  channel?: Maybe<LiveTvChannel>;
  channelsByGenre?: Maybe<Array<Maybe<Rail>>>;
  channelsByLanguage?: Maybe<Array<Maybe<Rail>>>;
  /** Get Collection of Contents : Header - 'x-access-token' */
  collection?: Maybe<Collection>;
  /** Get live feed commentary : Header - 'x-access-token' */
  commentary?: Maybe<CursorFeed>;
  commentsByTopic?: Maybe<Array<Maybe<Comment>>>;
  concurrentUsers?: Maybe<ConcurrentUsers>;
  contentDetail?: Maybe<SinglePlayBackContentDetail>;
  contestantById?: Maybe<Contestant>;
  contestants?: Maybe<Rail>;
  deviceCode?: Maybe<DeviceCode>;
  displayAds?: Maybe<AdDetail>;
  displayPlans?: Maybe<PlanDetail>;
  episodes?: Maybe<Rail>;
  error?: Maybe<Error>;
  /** User Facebook Login : Mandatory Headers - 'device_id', 'esk' */
  facebookLogin?: Maybe<Tokens>;
  feignTimeout?: Maybe<Scalars['String']>;
  forYouRailResultsByRailId?: Maybe<ForYouResultInRail>;
  /** Get gen AI search results in rail : Header - 'x-access-token' and 'Authorization' or 'guestToken'  */
  forYouResultsInRail?: Maybe<ForYouResultInRail>;
  /** Get force update details by platform name */
  forceUpdateDetails?: Maybe<Scalars['String']>;
  /** Send code to reset password Email/Mobile : Mandatory Headers - 'device_id', 'esk' */
  forgotPassword?: Maybe<UpdationResponse>;
  genAiSearchLanding?: Maybe<GenAiSearchLandingRail>;
  /** Get gen AI search results in rail : Header - 'x-access-token' and 'Authorization'  */
  genAiSearchResultsInRail?: Maybe<SearchResultInRail>;
  genresByAssetType?: Maybe<Array<Maybe<Genre>>>;
  getAds?: Maybe<AdsResponse>;
  /** User Google Login : Mandatory Headers - 'device_id', 'esk' */
  googleLogin?: Maybe<Tokens>;
  /** Get guest user details - guestUserId & x-access-token */
  guestUserDetails?: Maybe<GuestUser>;
  /** Check if ZEE5 user has onboarded to third party : Mandatory Headers -  'authorization', 'device_id', 'esk' */
  hasUserOnboardedToThirdParty?: Maybe<Scalars['Boolean']>;
  hipi?: Maybe<Array<Maybe<Rail>>>;
  /** Get Hybrid  search results in rail : Header - 'x-access-token'  */
  hybridSearchResults?: Maybe<SearchResultInRail>;
  isAddedToWatchList?: Maybe<Scalars['Boolean']>;
  isUserRegisteredToGamification?: Maybe<UserRegisterStatusResponse>;
  /** Get key-moments : Header - 'x-access-token' */
  keyMoments?: Maybe<CursorFeed>;
  languagesByAssetType?: Maybe<Array<Maybe<Language>>>;
  latestEpisode: Episode;
  liveTvGenres?: Maybe<Array<Maybe<Genre>>>;
  loggedInDevices?: Maybe<Array<Maybe<Device>>>;
  matches?: Maybe<Rail>;
  movie?: Maybe<Movie>;
  movies?: Maybe<Rail>;
  moviesByActors?: Maybe<Array<Maybe<Rail>>>;
  /** Get the currently playing program for given channel id : Header : 'x-access-token' */
  nowPlaying?: Maybe<Array<Maybe<Rail>>>;
  partnerSettings?: Maybe<PartnerSettings>;
  /**
   *     playerStats(gameType : GameType!) : LeaderBoardPlayer
   *     topPlayers(gameType : GameType!, limit : Int) : [LeaderBoardPlayer]
   *     rewardInfo(gameType : GameType!) : [PlayerReward]
   */
  playerStandingInCampaign?: Maybe<PlayerStanding>;
  playerStandingInTournament?: Maybe<PlayerStanding>;
  pointsTables?: Maybe<Rail>;
  pollByAssetId?: Maybe<Poll>;
  /** Get cart abandonment details : Header - 'x-access-token', 'authorization' */
  prepaidCodeVerification: PrepaidCodeVerificationDetails;
  /** Get all of today's program for given channel id : Header : 'x-access-token' */
  programGuide?: Maybe<Array<Maybe<Rail>>>;
  /** Get promptSuggestionByCategory : Header - 'x-access-token'  */
  promptSuggestionByCategory?: Maybe<PromptSuggestionByCategory>;
  /** Get promptSearchSuggestions : Header - 'x-access-token' and 'Authorization'  */
  promptSuggestions?: Maybe<PromptSuggestions>;
  /** Get Recommended Contents : Header - 'x-access-token', 'authorization' */
  recommended?: Maybe<Array<RecommendedRail>>;
  /** Refresh Auth Token with Refresh Token */
  refreshAuthToken?: Maybe<Tokens>;
  removeDevice?: Maybe<LogoutResponse>;
  /** Resend Confirmation Code for Email/Mobile used for Registration: Mandatory Headers - 'device_id', 'esk' */
  resendRegistrationConfirmation?: Maybe<UpdationResponse>;
  resolveEvent?: Maybe<ResolveEvent>;
  scorecard?: Maybe<ScoreCard>;
  /** Get search landing : Header - 'x-access-token' ' */
  searchLanding?: Maybe<Array<Maybe<RecommendedRail>>>;
  /** Get search results : Header - 'x-access-token' */
  searchResults?: Maybe<SearchQueryResult>;
  /** Get search results in rail : Header - 'x-access-token' */
  searchResultsInRail?: Maybe<SearchResultInRail>;
  /** Get search suggestions : Header - 'x-access-token' */
  searchSuggestions?: Maybe<SearchSuggestionResult>;
  /** Send OTP : Mandatory Headers - 'device_id', 'esk' */
  sendOtp?: Maybe<UpdationResponse>;
  sequentialTriviaQuestions?: Maybe<SequentialTriviaResponse>;
  similarContent?: Maybe<SimilarContent>;
  subscriptions?: Maybe<Array<Maybe<ZeeSubscription>>>;
  team?: Maybe<Team>;
  teams?: Maybe<Rail>;
  /** Get third party access details for ZEE5 user : Mandatory Headers -  'authorization', 'device_id', 'esk' */
  thirdPartyAccessDetails?: Maybe<ThirdPartyAccessDetails>;
  /** Exchange Auth Token with current Token : Mandatory Headers - 'authorization', 'device_id', 'esk' */
  tokenExchange?: Maybe<Tokens>;
  topContestants?: Maybe<Rail>;
  tournamentLeaderBoard?: Maybe<LeaderBoard>;
  tvShow?: Maybe<TvShow>;
  tvShowRelatedContent: TvShowRelatedContent;
  /** User Twitter Login : Mandatory Headers - 'device_id', 'esk' */
  twitterLogin?: Maybe<Tokens>;
  upNextContent?: Maybe<Rail>;
  upNextEpisodes?: Maybe<Rail>;
  /** Get User Details : Mandatory Headers - 'authorization', 'device_id', 'esk' */
  userDetails?: Maybe<UserDetails>;
  /** Check if user exists in ZEE5 by Email/Mobile */
  userExists?: Maybe<Scalars['Boolean']>;
  /** User Login Email/Mobile : Mandatory Headers - 'device_id', 'esk' */
  userLogin?: Maybe<Tokens>;
  userLoginAudit?: Maybe<Array<Maybe<UserLoginAuditData>>>;
  /** Get user rewards : Header - 'authorization' */
  userRewards?: Maybe<RewardResponse>;
  /** Get User Settings : Mandatory Headers - 'authorization', 'device_id', 'esk' */
  userSettings?: Maybe<Array<Maybe<UserSettings>>>;
  userSubscriptionDetails?: Maybe<Array<Maybe<UserSubscription>>>;
  userSubscriptionPurchaseDetails?: Maybe<Array<Maybe<UserSubscription>>>;
  /** Verify OTP : Mandatory Headers - 'device_id', 'esk' */
  verifyOtp?: Maybe<Tokens>;
  /** Verify OTP Register : Mandatory Headers - 'device_id', 'esk' */
  verifyOtpRegister?: Maybe<Tokens>;
  /** Mandatory Header - 'x-access-token', 'authorization' or 'x-z5-guest-token', Optional Header - 'profile-id' */
  watchHistory: Rail;
  watchList?: Maybe<Array<Maybe<Rail>>>;
  watchListBasedOnProfile?: Maybe<Array<Maybe<Rail>>>;
  watchPartyRoom?: Maybe<WatchPartyRoom>;
  zucasaUser?: Maybe<ZucasaUser>;
}

export interface QueryAdStacksArgs {
  assetId?: InputMaybe<Scalars['String']>;
}

export interface QueryAmazonLoginArgs {
  thirdPartyLoginInput: ThirdPartyLoginInput;
}

export interface QueryCampaignLeaderBoardArgs {
  campaignId: Scalars['String'];
  gameType: GameType;
  limit?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  tournamentId: Scalars['String'];
}

export interface QueryCelebrityDetailsArgs {
  seoId: Scalars['String'];
}

export interface QueryChannelArgs {
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  translation?: InputMaybe<Scalars['String']>;
}

export interface QueryChannelsByGenreArgs {
  filter: ChannelGenreFilter;
}

export interface QueryChannelsByLanguageArgs {
  filter: ChannelLanguageFilter;
}

export interface QueryCollectionArgs {
  filter?: InputMaybe<CollectionFilter>;
  id: Scalars['ID'];
}

export interface QueryCommentaryArgs {
  cursorId?: InputMaybe<Scalars['String']>;
  matchId: Scalars['ID'];
}

export interface QueryCommentsByTopicArgs {
  topicId: Scalars['String'];
}

export interface QueryConcurrentUsersArgs {
  country?: InputMaybe<Scalars['String']>;
  showId: Scalars['ID'];
}

export interface QueryContentDetailArgs {
  filter: ContentDetailFilter;
}

export interface QueryContestantByIdArgs {
  contestantId: Scalars['String'];
  seasonId?: InputMaybe<Scalars['String']>;
  tvShowId?: InputMaybe<Scalars['String']>;
}

export interface QueryContestantsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  seasonId: Scalars['String'];
  sortBy?: InputMaybe<ContestantSortBy>;
  sortOrder?: InputMaybe<ContestantSortOrder>;
  tvShowId: Scalars['String'];
}

export interface QueryDeviceCodeArgs {
  deviceName: Scalars['String'];
}

export interface QueryDisplayAdsArgs {
  filter: AdDetailFilter;
}

export interface QueryDisplayPlansArgs {
  code?: InputMaybe<Scalars['String']>;
  contentPartnerId?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['String']>;
  system: Scalars['String'];
}

export interface QueryEpisodesArgs {
  filter?: InputMaybe<EpisodeFilter>;
}

export interface QueryFacebookLoginArgs {
  thirdPartyLoginInput: ThirdPartyLoginInput;
}

export interface QueryForYouRailResultsByRailIdArgs {
  forYouRailResultsInput: ForYouRailResultsInput;
}

export interface QueryForYouResultsInRailArgs {
  forYouQueryInRailInput?: InputMaybe<ForYouQueryInRailInput>;
}

export interface QueryForceUpdateDetailsArgs {
  platform: Scalars['String'];
  version: Scalars['String'];
}

export interface QueryForgotPasswordArgs {
  forgotPasswordInput: ForgotPasswordInput;
}

export interface QueryGenAiSearchLandingArgs {
  genAiSearchLandingInput?: InputMaybe<GenAiSearchLandingInput>;
}

export interface QueryGenAiSearchResultsInRailArgs {
  searchQueryInRailInput: SearchQueryInRailInput;
}

export interface QueryGenresByAssetTypeArgs {
  filter: GenreOrLanguageFilter;
}

export interface QueryGetAdsArgs {
  adsCount?: InputMaybe<Scalars['String']>;
  timeStamp?: InputMaybe<Scalars['String']>;
  videoReferenceId?: InputMaybe<Scalars['String']>;
}

export interface QueryGoogleLoginArgs {
  thirdPartyLoginInput: ThirdPartyLoginInput;
}

export interface QueryGuestUserDetailsArgs {
  aId: Scalars['String'];
  apiKey: Scalars['String'];
  platform: Scalars['String'];
}

export interface QueryHasUserOnboardedToThirdPartyArgs {
  thirdPartyAccessType: ThirdPartyAccessType;
}

export interface QueryHipiArgs {
  filter: HipiFilter;
}

export interface QueryHybridSearchResultsArgs {
  searchQueryInRailInput: SearchQueryInRailInput;
}

export interface QueryIsAddedToWatchListArgs {
  id: Scalars['String'];
}

export interface QueryKeyMomentsArgs {
  cursorId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  matchId: Scalars['ID'];
}

export interface QueryLanguagesByAssetTypeArgs {
  filter: GenreOrLanguageFilter;
}

export interface QueryLatestEpisodeArgs {
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  translation?: InputMaybe<Scalars['String']>;
}

export interface QueryLiveTvGenresArgs {
  filter: GenreFilter;
}

export interface QueryMatchesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  seasonId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<InputMaybe<MatchStatus>>>;
  teamId?: InputMaybe<Scalars['ID']>;
  tournamentId: Scalars['ID'];
  translation?: InputMaybe<Scalars['String']>;
}

export interface QueryMovieArgs {
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  translation?: InputMaybe<Scalars['String']>;
}

export interface QueryMoviesArgs {
  filter: MovieFilter;
}

export interface QueryMoviesByActorsArgs {
  filter: MovieByActorsFilter;
}

export interface QueryNowPlayingArgs {
  filter: ProgramGuideFilter;
}

export interface QueryPartnerSettingsArgs {
  partnerKey: Scalars['String'];
}

export interface QueryPlayerStandingInCampaignArgs {
  campaignId: Scalars['String'];
  gameType: GameType;
  region?: InputMaybe<Scalars['String']>;
  tournamentId: Scalars['String'];
}

export interface QueryPlayerStandingInTournamentArgs {
  gameType: GameType;
  region?: InputMaybe<Scalars['String']>;
  tournamentId: Scalars['String'];
}

export interface QueryPointsTablesArgs {
  seasonId?: InputMaybe<Scalars['ID']>;
  tournamentId: Scalars['ID'];
}

export interface QueryPollByAssetIdArgs {
  assetId: Scalars['String'];
  translation?: InputMaybe<Scalars['String']>;
}

export interface QueryPrepaidCodeVerificationArgs {
  prepaidCodeVerificationInput: PrepaidCodeVerificationInput;
}

export interface QueryProgramGuideArgs {
  filter: ProgramGuideFilter;
}

export interface QueryRecommendedArgs {
  filter?: InputMaybe<RecommendedFilter>;
}

export interface QueryRefreshAuthTokenArgs {
  refreshToken: Scalars['String'];
}

export interface QueryRemoveDeviceArgs {
  deviceIds: Array<Scalars['String']>;
}

export interface QueryResendRegistrationConfirmationArgs {
  resendRegistrationConfirmationInput: ResendRegistrationConfirmationInput;
}

export interface QueryResolveEventArgs {
  id: Scalars['ID'];
}

export interface QueryScorecardArgs {
  matchId: Scalars['ID'];
}

export interface QuerySearchLandingArgs {
  input: SearchLandingInput;
}

export interface QuerySearchResultsArgs {
  searchQueryInput: SearchQueryInput;
}

export interface QuerySearchResultsInRailArgs {
  searchQueryInRailInput: SearchQueryInRailInput;
}

export interface QuerySearchSuggestionsArgs {
  searchSuggestionInput: SearchSuggestionInput;
}

export interface QuerySendOtpArgs {
  sendOtpInput: SendOtpInput;
}

export interface QuerySequentialTriviaQuestionsArgs {
  triviaCampaignId: Scalars['ID'];
}

export interface QuerySimilarContentArgs {
  filter: ContentFilter;
  id: Scalars['ID'];
}

export interface QuerySubscriptionsArgs {
  country: Scalars['String'];
  system?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface QueryTeamArgs {
  id: Scalars['ID'];
  seasonId: Scalars['ID'];
  tournamentId: Scalars['ID'];
}

export interface QueryTeamsArgs {
  seasonId?: InputMaybe<Scalars['ID']>;
  tournamentId: Scalars['ID'];
}

export interface QueryThirdPartyAccessDetailsArgs {
  thirdPartyAccessInput: ThirdPartyAccessInput;
}

export interface QueryTopContestantsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  seasonId: Scalars['String'];
  tvShowId: Scalars['String'];
}

export interface QueryTournamentLeaderBoardArgs {
  gameType: GameType;
  limit?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  tournamentId: Scalars['String'];
}

export interface QueryTvShowArgs {
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  translation?: InputMaybe<Scalars['String']>;
}

export interface QueryTvShowRelatedContentArgs {
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  platform?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface QueryTwitterLoginArgs {
  thirdPartyLoginInput: ThirdPartyLoginInput;
}

export interface QueryUpNextContentArgs {
  filter: UpNextFilter;
}

export interface QueryPersonalisedContentArgs {
  filter: PersonalizedFilter;
}

export interface QueryUpNextEpisodesArgs {
  filter: UpNextEpisodeFilter;
}

export interface QueryUserExistsArgs {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
}

export interface QueryUserLoginArgs {
  userLoginInput: UserLoginInput;
}

export interface QueryUserLoginAuditArgs {
  deviceId: Scalars['String'];
}

export interface QueryUserRewardsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  tournamentId: Scalars['ID'];
}

export interface QueryUserSubscriptionDetailsArgs {
  country: Scalars['String'];
  futureSubscription?: InputMaybe<Scalars['Boolean']>;
  includeAll?: InputMaybe<Scalars['Boolean']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface QueryVerifyOtpArgs {
  verifyOtpInput: VerifyOtpInput;
}

export interface QueryVerifyOtpRegisterArgs {
  verifyOtpRegisterInput: VerifyOtpRegisterInput;
}

export interface QueryWatchHistoryArgs {
  assetIds?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface QueryWatchListArgs {
  country?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface QueryWatchListBasedOnProfileArgs {
  country?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface QueryWatchPartyRoomArgs {
  zeeRoomId: Scalars['String'];
}

export interface Rail extends Pagination {
  __typename?: 'Rail';
  contentType?: Maybe<Scalars['String']>;
  contents?: Maybe<Array<Maybe<Content>>>;
  genres?: Maybe<Array<Maybe<KeyValuePair>>>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  modelId?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  modelVersion?: Maybe<Scalars['String']>;
  nextUrl?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  recoServed?: Maybe<Scalars['Boolean']>;
  showViewCount?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
  topContentPosition?: Maybe<Scalars['Int']>;
  totalResults?: Maybe<Scalars['Int']>;
}

export interface RecommendedFilter {
  ageRating?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  kidsSafe?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  recommendedContent?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  sourceType: RecommendedRailSource;
  state?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface RecommendedRail {
  __typename?: 'RecommendedRail';
  assetSubType?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  contents?: Maybe<Array<Maybe<Content>>>;
  genres?: Maybe<Array<Maybe<KeyValuePair>>>;
  heroFlag?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  modelName?: Maybe<Scalars['String']>;
  nextUrl?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  textNewsFlag?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  totalResults?: Maybe<Scalars['Int']>;
  webSideBarFlag?: Maybe<Scalars['Boolean']>;
}

export enum RecommendedRailSource {
  ConsumptionPage = 'consumptionPage',
  LandingPage = 'landingPage'
}

export interface RecreatePasswordInput {
  code: Scalars['String'];
  newPassword: Scalars['String'];
  type: LoginType;
  value: Scalars['String'];
}

export enum RegistrationType {
  Email = 'EMAIL',
  Mobile = 'MOBILE'
}

export interface RelatedCollection {
  __typename?: 'RelatedCollection';
  collections?: Maybe<Array<Maybe<Collection>>>;
  originalTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface RelatedCollectionCollectionsArgs {
  filter: CollectionFilter;
}

export interface RelatedContentId {
  __typename?: 'RelatedContentId';
  id?: Maybe<Scalars['String']>;
}

export interface ResendRegistrationConfirmationInput {
  type: RegistrationType;
  value: Scalars['String'];
}

export interface ResolveEvent {
  __typename?: 'ResolveEvent';
  assetId?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
}

export interface RewardDetail {
  __typename?: 'RewardDetail';
  allottedDate?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  itemDescription?: Maybe<Scalars['String']>;
  tournamentId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface RewardResponse {
  __typename?: 'RewardResponse';
  rewards?: Maybe<Array<Maybe<RewardDetail>>>;
}

export interface Rewards {
  __typename?: 'Rewards';
  createdAt?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deepLinkUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  noOfDaysToExpire?: Maybe<Scalars['String']>;
  winningAmount?: Maybe<Scalars['String']>;
}

export interface SpAdDetail {
  __typename?: 'SPAdDetail';
  adPriority?: Maybe<Array<Maybe<AttributeKeyValuePair>>>;
  companionAds?: Maybe<Array<Maybe<CompanionAd>>>;
  videoAds?: Maybe<Array<Maybe<VideoAd>>>;
  vmax?: Maybe<Vmax>;
}

export interface SpAssetDetail extends Content, ContentMetaData {
  __typename?: 'SPAssetDetail';
  actors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ageRating?: Maybe<Scalars['String']>;
  assetSubType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['Int']>;
  audioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingType?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  channels?: Maybe<Array<Maybe<Scalars['String']>>>;
  contentOwner?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionUrl?: Maybe<Scalars['String']>;
  directors?: Maybe<Array<Maybe<Scalars['String']>>>;
  drmKey?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  endCreditsStartTime?: Maybe<Scalars['String']>;
  eventLive?: Maybe<Scalars['Boolean']>;
  extended?: Maybe<ExtendedAssetDetail>;
  genres?: Maybe<Array<Maybe<KeyValuePair>>>;
  hlsUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  imageUrl?: Maybe<Scalars['String']>;
  isDrm?: Maybe<Scalars['Boolean']>;
  isRegistrationMandatory?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  onAir?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  originalTitle?: Maybe<Scalars['String']>;
  playDate?: Maybe<Scalars['String']>;
  playedDuration?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  releaseDate?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  showId?: Maybe<Scalars['String']>;
  skipIntro?: Maybe<SkipIntro>;
  slug?: Maybe<Scalars['String']>;
  subtitleLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtitleUrl?: Maybe<Array<Maybe<Subtitle>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  tier?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalEpisodes?: Maybe<Scalars['Int']>;
  useExternalSubtitle?: Maybe<Scalars['Boolean']>;
  video?: Maybe<Video>;
  vttThumbnailUrl?: Maybe<Scalars['String']>;
  webSlug?: Maybe<Scalars['String']>;
  webUrl?: Maybe<Scalars['String']>;
}

export interface Score {
  __typename?: 'Score';
  overs?: Maybe<Scalars['String']>;
  requiredRunRate?: Maybe<Scalars['String']>;
  runRate?: Maybe<Scalars['String']>;
  runs?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  wickets?: Maybe<Scalars['String']>;
}

export interface ScoreCard {
  __typename?: 'ScoreCard';
  currentBatsmen?: Maybe<Array<Maybe<Batsman>>>;
  currentBowlers?: Maybe<Array<Maybe<Bowler>>>;
  endDate?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['String']>;
  innings?: Maybe<Array<Maybe<Innings>>>;
  latestInningsNumber?: Maybe<Scalars['Int']>;
  matchId?: Maybe<Scalars['String']>;
  matchState?: Maybe<Scalars['String']>;
  matchStatus?: Maybe<MatchStatus>;
  metaData?: Maybe<MetaData>;
  recentScores?: Maybe<Array<Maybe<Scalars['String']>>>;
  result?: Maybe<Scalars['String']>;
  score?: Maybe<Score>;
  seasonId?: Maybe<Scalars['String']>;
  shortTitle?: Maybe<Scalars['String']>;
  sportsType?: Maybe<SportsType>;
  startDate?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['String']>;
  statusNote?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  teamA?: Maybe<TeamScore>;
  teamB?: Maybe<TeamScore>;
  title?: Maybe<Scalars['String']>;
  toss?: Maybe<Toss>;
  tournamentId?: Maybe<Scalars['String']>;
  venue?: Maybe<MatchVenue>;
}

export enum SearchApiPath {
  Collections = 'collections',
  Results = 'results'
}

export interface SearchFilter {
  __typename?: 'SearchFilter';
  isActive?: Maybe<Scalars['Boolean']>;
  optionType?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<SearchFilterOption>>>;
  queryParam?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface SearchFilterOption {
  __typename?: 'SearchFilterOption';
  applied?: Maybe<Scalars['Boolean']>;
  count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

export interface SearchLandingInput {
  city?: InputMaybe<Scalars['String']>;
  /** country should be COMPLETE String */
  country: Scalars['String'];
  languages: Scalars['String'];
  pcAge?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SearchApiPath>;
}

export interface SearchQueryFilter {
  genre?: InputMaybe<Array<Scalars['String']>>;
  lang?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
}

export interface SearchQueryInRailInput {
  ageRating?: InputMaybe<Scalars['Int']>;
  autoCorrect?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<SearchQueryFilter>;
  languages?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  parent?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  restrictContentPlan?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UserType>;
}

export interface SearchQueryInput {
  ageRating?: InputMaybe<Scalars['Int']>;
  autocorrect?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<SearchQueryFilter>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  parent?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  restrictContentPlan?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface SearchQueryResult extends PaginationCommon {
  __typename?: 'SearchQueryResult';
  currentPageIndex?: Maybe<Scalars['Int']>;
  currentResultsCount?: Maybe<Scalars['Int']>;
  filters?: Maybe<Array<Maybe<SearchFilter>>>;
  isFilterEnabled?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  queryId?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<SearchResult>>>;
  totalPages?: Maybe<Scalars['Int']>;
  totalResultsCount?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['String']>;
}

export interface SearchRail {
  __typename?: 'SearchRail';
  contents?: Maybe<Array<Maybe<Content>>>;
  id?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  railSource?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
}

export interface SearchRelevanceInfo {
  __typename?: 'SearchRelevanceInfo';
  searchCorrelationId?: Maybe<Scalars['String']>;
  searchResultPosition?: Maybe<Scalars['Int']>;
}

export interface SearchResult {
  __typename?: 'SearchResult';
  actors?: Maybe<Array<Maybe<Scalars['String']>>>;
  assetSubType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['Int']>;
  audioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingType?: Maybe<Scalars['String']>;
  broadcastState?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  channelName?: Maybe<SearchResultChannelName>;
  contentOwner?: Maybe<Scalars['String']>;
  contentPartner?: Maybe<ContentPartner>;
  contentType?: Maybe<Scalars['String']>;
  coverImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  distinctSeqId?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  genre?: Maybe<Array<Maybe<SearchResultGenre>>>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<SearchResultImage>;
  imageUrl?: Maybe<Scalars['String']>;
  isIndiaImageEnabled?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  listImage?: Maybe<Scalars['String']>;
  onAir?: Maybe<Scalars['Boolean']>;
  originalTitle?: Maybe<Scalars['String']>;
  overlayImageCircleDark?: Maybe<OverlayImage>;
  overlayImageCircleWhite?: Maybe<OverlayImage>;
  overlayImagePurchaseImage?: Maybe<OverlayImage>;
  overlayImageRectangleDark?: Maybe<OverlayImage>;
  overlayImageRectangleWhite?: Maybe<OverlayImage>;
  primaryGenre?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['String']>;
  searchRelevanceInfo?: Maybe<SearchRelevanceInfo>;
  slug?: Maybe<Scalars['String']>;
  subtitleLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  tier?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  tvShow?: Maybe<TvShowFragment>;
}

export interface SearchResultChannelName {
  __typename?: 'SearchResultChannelName';
  id?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
}

export interface SearchResultGenre {
  __typename?: 'SearchResultGenre';
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

export interface SearchResultImage {
  __typename?: 'SearchResultImage';
  appCover?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['String']>;
  list?: Maybe<Scalars['String']>;
  listClean?: Maybe<Scalars['String']>;
  portrait?: Maybe<Scalars['String']>;
  portraitClean?: Maybe<Scalars['String']>;
  square?: Maybe<Scalars['String']>;
  tvCover?: Maybe<Scalars['String']>;
}

export interface SearchResultInRail {
  __typename?: 'SearchResultInRail';
  filters?: Maybe<Array<Maybe<SearchFilter>>>;
  queryId?: Maybe<Scalars['String']>;
  rails?: Maybe<Array<Maybe<SearchRail>>>;
  suggestedPrompts?: Maybe<SuggestedPrompts>;
  total?: Maybe<Scalars['Int']>;
}

export interface SearchSuggestion {
  __typename?: 'SearchSuggestion';
  filter?: Maybe<SearchSuggestionFilter>;
  in?: Maybe<Scalars['String']>;
  searchRelevanceInfo?: Maybe<SearchRelevanceInfo>;
  text?: Maybe<Scalars['String']>;
}

export interface SearchSuggestionFilter {
  __typename?: 'SearchSuggestionFilter';
  genre?: Maybe<Array<Maybe<Scalars['String']>>>;
  lang?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Array<Maybe<Scalars['Int']>>>;
}

export interface SearchSuggestionInput {
  ageRating?: InputMaybe<Scalars['Int']>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
}

export interface SearchSuggestionResult extends PaginationCommon {
  __typename?: 'SearchSuggestionResult';
  currentPageIndex?: Maybe<Scalars['Int']>;
  currentResultsCount?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  suggestions?: Maybe<Array<Maybe<SearchSuggestion>>>;
  totalPages?: Maybe<Scalars['Int']>;
  totalResultsCount?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['String']>;
}

export interface Season extends Content {
  __typename?: 'Season';
  actors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ageRating?: Maybe<Scalars['String']>;
  assetSubType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['Int']>;
  audioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingType?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  clips?: Maybe<Array<Maybe<Episode>>>;
  contentOwner?: Maybe<Scalars['String']>;
  contentPartnerDetails?: Maybe<ContentPartner>;
  description?: Maybe<Scalars['String']>;
  directors?: Maybe<Array<Maybe<Scalars['String']>>>;
  duration?: Maybe<Scalars['Int']>;
  episodes?: Maybe<Array<Maybe<Episode>>>;
  eventLive?: Maybe<Scalars['Boolean']>;
  genres?: Maybe<Array<Maybe<KeyValuePair>>>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  index?: Maybe<Scalars['Int']>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  mobisodes?: Maybe<Array<Maybe<Episode>>>;
  nextClipsApi?: Maybe<Scalars['String']>;
  nextEpisodesApi?: Maybe<Scalars['String']>;
  nextMobisodesApi?: Maybe<Scalars['String']>;
  nextPreviewsApi?: Maybe<Scalars['String']>;
  nextPromosApi?: Maybe<Scalars['String']>;
  nextSamplePremiumsApi?: Maybe<Scalars['String']>;
  nextTeasersApi?: Maybe<Scalars['String']>;
  nextTrailersApi?: Maybe<Scalars['String']>;
  nextWebisodesApi?: Maybe<Scalars['String']>;
  onAir?: Maybe<Scalars['Boolean']>;
  orderId?: Maybe<Scalars['Int']>;
  originalTitle?: Maybe<Scalars['String']>;
  previews?: Maybe<Array<Maybe<Episode>>>;
  promos?: Maybe<Array<Maybe<Episode>>>;
  releaseDate?: Maybe<Scalars['String']>;
  samplePremiums?: Maybe<Array<Maybe<Episode>>>;
  seasonFilter?: Maybe<SeasonFilter>;
  subtitleLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  teasers?: Maybe<Array<Maybe<Episode>>>;
  tier?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalClips?: Maybe<Scalars['Int']>;
  totalEpisodes?: Maybe<Scalars['Int']>;
  totalMobisodes?: Maybe<Scalars['Int']>;
  totalPreviews?: Maybe<Scalars['Int']>;
  totalPromos?: Maybe<Scalars['Int']>;
  totalSamplePremiums?: Maybe<Scalars['Int']>;
  totalTeasers?: Maybe<Scalars['Int']>;
  totalTrailers?: Maybe<Scalars['Int']>;
  totalWebisodes?: Maybe<Scalars['Int']>;
  trailers?: Maybe<Array<Maybe<Episode>>>;
  webisodes?: Maybe<Array<Maybe<Episode>>>;
}

export interface SeasonFilter {
  __typename?: 'SeasonFilter';
  filterByYear?: Maybe<Array<Maybe<SeasonFilterByYear>>>;
}

export interface SeasonFilterByMonth {
  __typename?: 'SeasonFilterByMonth';
  apiUrl?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
}

export interface SeasonFilterByYear {
  __typename?: 'SeasonFilterByYear';
  filterByMonth?: Maybe<Array<Maybe<SeasonFilterByMonth>>>;
  year?: Maybe<Scalars['String']>;
}

export interface SecurityCapability {
  __typename?: 'SecurityCapability';
  encryption?: Maybe<Array<Maybe<Scalars['String']>>>;
  hdcpVersion?: Maybe<Array<Maybe<Scalars['String']>>>;
  widevineSecurityLevel?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface SellerDetails {
  __typename?: 'SellerDetails';
  domain?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

export interface SendOtpInput {
  hashId?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  type: LoginType;
  value: Scalars['String'];
}

export interface SequentialQuestion {
  __typename?: 'SequentialQuestion';
  campaignId?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<OptionResponse>>>;
  pointsForCorrectAnswer?: Maybe<Scalars['Int']>;
  questionText?: Maybe<Scalars['String']>;
  userAnswerResponse?: Maybe<AnswerResponse>;
}

export interface SequentialTriviaResponse {
  __typename?: 'SequentialTriviaResponse';
  gameMetaData?: Maybe<GameMetaData>;
  triviaQuestions?: Maybe<Array<Maybe<SequentialQuestion>>>;
}

export interface SimilarContent extends Content, ContentMetaData {
  __typename?: 'SimilarContent';
  actors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ageRating?: Maybe<Scalars['String']>;
  assetSubType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['Int']>;
  audioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingType?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  contentOwner?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  directors?: Maybe<Array<Maybe<Scalars['String']>>>;
  duration?: Maybe<Scalars['Int']>;
  eventLive?: Maybe<Scalars['Boolean']>;
  genres?: Maybe<Array<Maybe<KeyValuePair>>>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  originalTitle?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  relatedChannels?: Maybe<Rail>;
  relatedCollections?: Maybe<RelatedCollection>;
  relatedMovies?: Maybe<Rail>;
  relatedTvShows?: Maybe<Rail>;
  relatedVideos?: Maybe<Rail>;
  releaseDate?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  subtitleLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  tier?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  video?: Maybe<Video>;
  webUrl?: Maybe<Scalars['String']>;
}

export interface SinglePlayBackContentDetail {
  __typename?: 'SinglePlayBackContentDetail';
  adDetail?: Maybe<SpAdDetail>;
  assetDetail?: Maybe<SpAssetDetail>;
  entitlement?: Maybe<Entitlement>;
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  keyOsDetail?: Maybe<KeyOsDetail>;
  showDetail?: Maybe<SpAssetDetail>;
  trailerDetail?: Maybe<SpAssetDetail>;
  watchHistory?: Maybe<ContentWatchHistory>;
}

export interface SkipIntro {
  __typename?: 'SkipIntro';
  introEndTime?: Maybe<Scalars['String']>;
  introStartTime?: Maybe<Scalars['String']>;
}

export interface SocialMediaReviews {
  __typename?: 'SocialMediaReviews';
  infoTag?: Maybe<Scalars['String']>;
  review?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}

export enum SportsType {
  Badminton = 'Badminton',
  Baseball = 'Baseball',
  Basketball = 'Basketball',
  Cricket = 'Cricket',
  Football = 'Football',
  Hockey = 'Hockey',
  Tennis = 'Tennis'
}

export interface SubmitAnswerInput {
  gameId?: InputMaybe<Scalars['String']>;
  questionId?: InputMaybe<Scalars['String']>;
  userSelectedOptionId?: InputMaybe<Scalars['String']>;
}

export interface SubmitPollResponseInput {
  category?: InputMaybe<Scalars['String']>;
  pollId: Scalars['String'];
  questionId: Scalars['String'];
  selectedOptionId: Scalars['String'];
}

export interface Subtitle {
  __typename?: 'Subtitle';
  language?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
}

export interface SuggestedPrompts {
  __typename?: 'SuggestedPrompts';
  prompts?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
}

export interface TvShow extends Content, ContentMetaData {
  __typename?: 'TVShow';
  actors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ageRating?: Maybe<Scalars['String']>;
  assetSubType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['Int']>;
  audioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingType?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  clickID?: Maybe<Scalars['String']>;
  contentDescriptors?: Maybe<Array<Maybe<Scalars['String']>>>;
  contentOwner?: Maybe<Scalars['String']>;
  contentPartner?: Maybe<ContentPartner>;
  contentPartnerAssetId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  drmKey?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  episodeNumber?: Maybe<Scalars['Int']>;
  episodes?: Maybe<Array<Maybe<Episode>>>;
  genres?: Maybe<Array<Maybe<KeyValuePair>>>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  imageType?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Image>;
  imdbRating?: Maybe<Scalars['Float']>;
  introEndTime?: Maybe<Scalars['String']>;
  introStartTime?: Maybe<Scalars['String']>;
  isAddedToWatchList?: Maybe<Scalars['Boolean']>;
  isDrm?: Maybe<Scalars['Int']>;
  isLiked?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  matchScore?: Maybe<Scalars['Int']>;
  onAir?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  overlayImageRectangleWhite?: Maybe<OverlayImage>;
  parentAsset?: Maybe<KeyValuePair>;
  playDate?: Maybe<Scalars['String']>;
  playedDuration?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  releaseDate?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  socialMediaReviews?: Maybe<Array<Maybe<SocialMediaReviews>>>;
  subtitleLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  thumbnails?: Maybe<Array<Maybe<Image>>>;
  tier?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topContentPosition?: Maybe<Scalars['Int']>;
  video?: Maybe<Video>;
  videoUri?: Maybe<Video>;
  viewCount?: Maybe<ViewCount>;
  webUrl?: Maybe<Scalars['String']>;
}

export interface TvShowFragment {
  __typename?: 'TVShowFragment';
  assetSubType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface TableColumns {
  __typename?: 'TableColumns';
  field?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
}

export interface Team extends Content {
  __typename?: 'Team';
  coach?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  originalTitle?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  players?: Maybe<Array<Maybe<Player>>>;
  playersByCategory?: Maybe<Array<Maybe<PlayersByCategory>>>;
  relatedCollectionId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  sportsType?: Maybe<SportsType>;
  teamName?: Maybe<Scalars['String']>;
  teamStatistics?: Maybe<TeamStatistics>;
  title?: Maybe<Scalars['String']>;
  tournamentId?: Maybe<Scalars['String']>;
}

export interface TeamScore {
  __typename?: 'TeamScore';
  id?: Maybe<Scalars['String']>;
  /** Should we just use a single field like logoUrl or an image obj?? */
  image?: Maybe<Image>;
  scoreAttributes?: Maybe<Array<Maybe<AttributeKeyValuePair>>>;
  shortName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  vendorTeamId?: Maybe<Scalars['String']>;
}

export interface TeamStatistics {
  __typename?: 'TeamStatistics';
  lost?: Maybe<Scalars['String']>;
  netRunRate?: Maybe<Scalars['String']>;
  played?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['String']>;
  won?: Maybe<Scalars['String']>;
}

export interface ThirdPartyAccessDetails {
  __typename?: 'ThirdPartyAccessDetails';
  isNewRegistration?: Maybe<Scalars['Boolean']>;
  lastLoginTime?: Maybe<Scalars['String']>;
  registrationRegion?: Maybe<Scalars['String']>;
  termsAndConditionsAcceptanceDate?: Maybe<Scalars['String']>;
  thirdPartyAttributes?: Maybe<Array<Maybe<AttributeKeyValuePair>>>;
  thirdPartyUserId?: Maybe<Scalars['String']>;
  thirdPartyUserName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  tokenExpirationTime?: Maybe<Scalars['String']>;
  type?: Maybe<ThirdPartyAccessType>;
  zeeUserId?: Maybe<Scalars['String']>;
}

export interface ThirdPartyAccessInput {
  registrationRegion?: InputMaybe<Scalars['String']>;
  thirdPartyUserName?: InputMaybe<Scalars['String']>;
  type: ThirdPartyAccessType;
}

export enum ThirdPartyAccessType {
  Playfab = 'PLAYFAB'
}

export interface ThirdPartyLoginInput {
  token: Scalars['String'];
}

export interface ThirdPartyRegistrationInput {
  additionalInfo?: InputMaybe<UserRegistrationAdditionalInfo>;
  ipAddress?: InputMaybe<Scalars['String']>;
  macAddress?: InputMaybe<Scalars['String']>;
  registrationCountry?: InputMaybe<Scalars['String']>;
  registrationRegion?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  type: ThirdPartyRegistrationType;
}

export enum ThirdPartyRegistrationType {
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  Twitter = 'TWITTER'
}

export interface Tokens {
  __typename?: 'Tokens';
  authToken?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['String']>;
  secureToken?: Maybe<Scalars['String']>;
  shouldRegister?: Maybe<Scalars['Int']>;
  tokenType?: Maybe<Scalars['String']>;
}

export interface Toss {
  __typename?: 'Toss';
  decision?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  winner?: Maybe<Scalars['String']>;
}

export interface TrueCallerAndroidRegisterUserInput {
  requestId: Scalars['String'];
  shouldRegister: Scalars['Int'];
}

export interface TrueCallerAndroidUpdateInput {
  payload: Scalars['String'];
  signature: Scalars['String'];
  signatureAlgorithm: Scalars['String'];
  update: Scalars['Int'];
}

export interface TrueCallerMergeInput {
  authToken?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  otp?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  registeredEmail?: InputMaybe<Scalars['String']>;
  registeredMobile?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<Scalars['String']>;
  secureToken?: InputMaybe<Scalars['String']>;
  type: TrueCallerMergeType;
}

export enum TrueCallerMergeType {
  Apple = 'APPLE',
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  Mobile = 'MOBILE',
  Twitter = 'TWITTER'
}

export interface TvShowRelatedContent extends Content, ContentMetaData {
  __typename?: 'TvShowRelatedContent';
  actors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ageRating?: Maybe<Scalars['String']>;
  assetSubType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['Int']>;
  audioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingType?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  contentOwner?: Maybe<Scalars['String']>;
  contentPartnerDetails?: Maybe<ContentPartner>;
  description?: Maybe<Scalars['String']>;
  directors?: Maybe<Array<Maybe<Scalars['String']>>>;
  duration?: Maybe<Scalars['Int']>;
  episodeNumber?: Maybe<Scalars['Int']>;
  eventLive?: Maybe<Scalars['Boolean']>;
  extended?: Maybe<ExtendedAssetDetail>;
  genres?: Maybe<Array<Maybe<KeyValuePair>>>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  originalTitle?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  relatedChannels?: Maybe<Rail>;
  relatedCollections?: Maybe<RelatedCollection>;
  relatedMovies?: Maybe<Rail>;
  relatedTvShows?: Maybe<Rail>;
  relatedVideos?: Maybe<Rail>;
  releaseDate?: Maybe<Scalars['String']>;
  seasons?: Maybe<Array<Maybe<Season>>>;
  seoTitle?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  subtitleLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  tier?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  video?: Maybe<Video>;
  webSlug?: Maybe<Scalars['String']>;
  webUrl?: Maybe<Scalars['String']>;
}

export interface UpNextEpisodeFilter {
  country?: InputMaybe<Scalars['String']>;
  episodeId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  seasonId: Scalars['String'];
  translation?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
}

export interface UpNextFilter {
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  translation?: InputMaybe<Scalars['String']>;
}

export interface PersonalizedFilter {
  id: Scalars['String'];
  personalizationType: Scalars['String'];
  personalizationMetaData: Scalars['String'];
  sourceType?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  translation: Scalars['String'];
  languages: Scalars['String'];
  region?: InputMaybe<Scalars['String']>;
  kidsSafe?: InputMaybe<Scalars['String']>;
  ageRating?: InputMaybe<Scalars['String']>;
  recommendedContent?: InputMaybe<Scalars['String']>;
  assetIds?: InputMaybe<Scalars['String']>;
}

export interface UpdatePasswordInput {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
  recipientEmail: Scalars['String'];
}

export interface UpdateUserDetailsInput {
  birthDate?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  macAddress?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
}

export interface UpdationResponse {
  __typename?: 'UpdationResponse';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
}

export interface UpgradeSubscription {
  __typename?: 'UpgradeSubscription';
  defaultPlan?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<Feature>>>;
  plans?: Maybe<Array<Maybe<Plan>>>;
}

export interface UserDetails {
  __typename?: 'UserDetails';
  activated?: Maybe<Scalars['Boolean']>;
  activationDate?: Maybe<Scalars['String']>;
  additional?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  isPasswordAttached?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  macAddress?: Maybe<Scalars['String']>;
  registrationCountry?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
}

export interface UserLoginAuditData {
  __typename?: 'UserLoginAuditData';
  deviceId?: Maybe<Scalars['String']>;
  loggedInTime?: Maybe<Scalars['String']>;
  loggedOutTime?: Maybe<Scalars['String']>;
  userCity?: Maybe<Scalars['String']>;
  userCountry?: Maybe<Scalars['String']>;
  userIp?: Maybe<Scalars['String']>;
  userState?: Maybe<Scalars['String']>;
}

export interface UserLoginInput {
  appId?: InputMaybe<Scalars['String']>;
  device?: InputMaybe<Scalars['String']>;
  guestToken: Scalars['String'];
  lotameCookieId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  platform: Scalars['String'];
  type: LoginType;
  value: Scalars['String'];
}

export interface UserRegisterResponse {
  __typename?: 'UserRegisterResponse';
  userName?: Maybe<Scalars['String']>;
}

export interface UserRegisterStatusResponse {
  __typename?: 'UserRegisterStatusResponse';
  status?: Maybe<Scalars['Boolean']>;
}

export interface UserRegistrationAdditionalInfo {
  firstTimeLogin?: InputMaybe<Scalars['String']>;
  gdprPolicy?: InputMaybe<Array<InputMaybe<UserRegistrationPolicy>>>;
  guestToken?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  promotional?: InputMaybe<PromotionalData>;
  sourceApp?: InputMaybe<Scalars['String']>;
  versionNumber?: InputMaybe<Scalars['String']>;
}

export interface UserRegistrationInput {
  additionalInfo?: InputMaybe<UserRegistrationAdditionalInfo>;
  firstName: Scalars['String'];
  ipAddress: Scalars['String'];
  lastName: Scalars['String'];
  macAddress: Scalars['String'];
  password: Scalars['String'];
  registrationCountry: Scalars['String'];
  registrationRegion?: InputMaybe<Scalars['String']>;
  type: RegistrationType;
  value: Scalars['String'];
}

export interface UserRegistrationPolicy {
  countryCode?: InputMaybe<Scalars['String']>;
  gdprFields?: InputMaybe<PolicyFields>;
}

export interface UserResponse {
  __typename?: 'UserResponse';
  isOptionCorrect?: Maybe<Scalars['Boolean']>;
  questionId?: Maybe<Scalars['String']>;
  selectedOptionId?: Maybe<Scalars['String']>;
}

export interface UserSettings {
  __typename?: 'UserSettings';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

export interface UserSettingsInput {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
}

export interface UserSubscription {
  __typename?: 'UserSubscription';
  additionalDetails?: Maybe<UserSubscriptionAdditionalDetails>;
  allowedBillingCycles?: Maybe<Scalars['Int']>;
  assetId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createDate?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  freeTrial?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  paymentProvider?: Maybe<Scalars['String']>;
  playbackEndDate?: Maybe<Scalars['String']>;
  playbackState?: Maybe<Scalars['String']>;
  purchaseEnd?: Maybe<Scalars['String']>;
  recurringEnabled?: Maybe<Scalars['Boolean']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subscriptionEnd?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<ZeeSubscription>;
  subscriptionStart?: Maybe<Scalars['String']>;
  usedBillingCycles?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
}

export interface UserSubscriptionAdditionalDetails {
  __typename?: 'UserSubscriptionAdditionalDetails';
  extra?: Maybe<Scalars['String']>;
  jira?: Maybe<Scalars['String']>;
  offers?: Maybe<Array<Maybe<Offer>>>;
  partner?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<Scalars['String']>;
  paymentMode?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
}

export enum UserType {
  Guest = 'guest',
  Premium = 'premium',
  Registered = 'registered'
}

export interface VerifyOtpInput {
  otp: Scalars['String'];
  type: LoginType;
  value: Scalars['String'];
}

export interface VerifyOtpRegisterInput {
  requestId?: InputMaybe<Scalars['String']>;
  secureToken: Scalars['String'];
  type: LoginType;
  value: Scalars['String'];
}

export interface Video {
  __typename?: 'Video';
  avcUri?: Maybe<Scalars['String']>;
  drmKey?: Maybe<Scalars['String']>;
  hevcUri?: Maybe<Scalars['String']>;
  hlsUrl?: Maybe<Scalars['String']>;
  isDrm?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
}

export interface VideoAd {
  __typename?: 'VideoAd';
  adIntervals?: Maybe<Array<Maybe<AdInterval>>>;
  adVisibility?: Maybe<Scalars['Boolean']>;
  adsUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}

export interface VideoBreak {
  __typename?: 'VideoBreak';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<VideoBreakValue>;
}

export interface VideoBreakValue {
  __typename?: 'VideoBreakValue';
  adSpotKey?: Maybe<Scalars['String']>;
  allowOnlyCompleteAd?: Maybe<Scalars['Boolean']>;
  companionParams?: Maybe<CompanionParam>;
  expectedTime?: Maybe<Scalars['Int']>;
  maxTime?: Maybe<Scalars['Int']>;
  orderByTimeAscending?: Maybe<Scalars['Boolean']>;
  requestedAds?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['String']>;
  useTotalDurationForCompleteAd?: Maybe<Scalars['Boolean']>;
}

export interface ViewCount {
  __typename?: 'ViewCount';
  count?: Maybe<Scalars['String']>;
  formattedCount?: Maybe<Scalars['String']>;
}

export interface Vmax {
  __typename?: 'Vmax';
  accountId?: Maybe<Scalars['String']>;
  displayAds?: Maybe<DisplayAds>;
  keyValues?: Maybe<VmaxKeyValues>;
  videoBreak?: Maybe<Array<Maybe<VideoBreak>>>;
}

export interface VmaxKeyValues {
  __typename?: 'VmaxKeyValues';
  adPos?: Maybe<Scalars['Int']>;
  age?: Maybe<Scalars['String']>;
  ageGroup?: Maybe<Scalars['String']>;
  appVersion?: Maybe<Scalars['String']>;
  assetSubtype?: Maybe<Scalars['String']>;
  aud?: Maybe<Scalars['String']>;
  audioLanguage?: Maybe<Scalars['String']>;
  bdSource?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  ca?: Maybe<Scalars['String']>;
  certificateType?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['String']>;
  contentCreator?: Maybe<Scalars['String']>;
  contentLength?: Maybe<Scalars['String']>;
  contentName?: Maybe<Scalars['String']>;
  cuePoint?: Maybe<Scalars['String']>;
  episodeNumber?: Maybe<Scalars['Int']>;
  gender?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
  isLat?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  screenId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  showId?: Maybe<Scalars['String']>;
  showName?: Maybe<Scalars['String']>;
  translation?: Maybe<Scalars['String']>;
  userLanguage?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
  videoId?: Maybe<Scalars['String']>;
  videoTitle?: Maybe<Scalars['String']>;
}

export interface WatchHistoryInput {
  assetType: Scalars['Int'];
  deviceId: Scalars['String'];
  duration: Scalars['Int'];
  id: Scalars['String'];
}

export interface WatchListInput {
  assetType: Scalars['Int'];
  date: Scalars['String'];
  duration: Scalars['Int'];
  id: Scalars['String'];
}

export interface WatchPartyRoom {
  __typename?: 'WatchPartyRoom';
  zeeRoomId?: Maybe<Scalars['String']>;
  zucasaRoomId?: Maybe<Scalars['String']>;
}

export interface Wicket {
  __typename?: 'Wicket';
  ballsFaced?: Maybe<Scalars['String']>;
  batsmanId?: Maybe<Scalars['String']>;
  batsmanName?: Maybe<Scalars['String']>;
  bowlerId?: Maybe<Scalars['String']>;
  dismissal?: Maybe<Scalars['String']>;
  dismissalDetails?: Maybe<Scalars['String']>;
  dismissalOver?: Maybe<Scalars['String']>;
  dismissalScore?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  runsScored?: Maybe<Scalars['String']>;
}

export interface YetToBat {
  __typename?: 'YetToBat';
  name?: Maybe<Scalars['String']>;
  playerId?: Maybe<Scalars['String']>;
}

export interface ZeeSubscription {
  __typename?: 'ZeeSubscription';
  allowedPlaybackDuration?: Maybe<Scalars['Int']>;
  assetIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  assetType?: Maybe<Scalars['String']>;
  assetTypes?: Maybe<Array<Maybe<Scalars['Int']>>>;
  billingCycleType?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['Int']>;
  billingType?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  channelAudioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  contentPartner?: Maybe<Array<Maybe<ContentPartner>>>;
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  durationText?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  movieAudioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  numberOfSupportedDevices?: Maybe<Scalars['Int']>;
  onlyAvailableWithPromotion?: Maybe<Scalars['Boolean']>;
  originalTitle?: Maybe<Scalars['String']>;
  paymentProviders?: Maybe<Array<Maybe<PaymentProvider>>>;
  price?: Maybe<Scalars['Float']>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  recurring?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['String']>;
  subscriptionPlanType?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  tvShowAudioLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  validForAllCountries?: Maybe<Scalars['Boolean']>;
}

export interface ZucasaToken {
  __typename?: 'ZucasaToken';
  token?: Maybe<Scalars['String']>;
}

export interface ZucasaUser {
  __typename?: 'ZucasaUser';
  zucasaUser?: Maybe<Scalars['String']>;
}

export interface ZucasaUserInput {
  zucasaUser?: InputMaybe<Scalars['String']>;
}

export interface _Service {
  __typename?: '_Service';
  sdl: Scalars['String'];
}

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper
) {
  return {};
}
export type Sdk = ReturnType<typeof getSdk>;
